import React, {
  forwardRef,
  use,
  useEffect,
  useState,
  useRef,
  useCallback,
} from "react";
import { useParams } from "react-router-dom";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import { Link as RouterLink } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { TextField, IconButton, Tabs, Tab, Alert } from "@mui/material";
import Box from "@mui/material/Box";
import { DataGrid, useGridApiRef } from "@mui/x-data-grid";
import QuotationDocs from "./QuotationDocs";
import PhotoCameraIcon from "@mui/icons-material/PhotoCamera";
import RelatedDocs from "./RelatedDocs";
import ImageModal from "./ImageModal";
import { useBreadcrumbs } from "./BreadcrumbsContext";
import CustomerDetailsTab from "../tabs/CustomerDetailsTab";
import { OtherDetailsTab } from "../tabs/OtherDetailsTab";
import { HistoryDetailsTab } from "../tabs/HistoryDetailsTab";
import { Switch, FormControlLabel } from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import axios from "axios";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import ProductsInQuotation from "../components/lead_and_quotation/ProductsInQuotation";
import { format } from "date-fns";
import ItemSearchPopup from "../components/lead_and_quotation/ItemSearchPopup";
import ItemSearchPopupQuotation from "../components/lead_and_quotation/ItemSearchPopupQuotation";
import SalesTab from "../tabs/UnifiedSalesTab";

import Modal from "../components/common/CommonModal";

import ProductsModal from "../components/salesInvoice/ProductsModal";

import useApi from "../hooks/useApi";

import canUserSeeThis from "../components/common/CheckCanUserSeeThis";
import { downloadQuotationExcel } from "./downloadQuotationExcel"; 

const QuotationComponent = ({ productDetails, onClose }) => {

  const [discountPercentage, setDiscountPercentage] = useState(0)
  const [departmentLocationForItemSearch, setDepartmentLocationForItemSearch] = useState("A")
  const [
    productsInQuotationAsFromApiForPDF,
    setProductsInQuotationAsFromApiForPDF,
  ] = useState(null);

  const [cashCustomerList, setCashCustomerList] = useState([]);

  const [showDropdown, setShowDropdown] = useState(false);

  const [confirmDeleteTemplate, setConfirmDeleteTemplate] = useState(null); // stores mastercode to delete

  const { request, loading } = useApi();

  const debounceTimer = useRef(null);

  const [modalPageNumber, setModalPageNumber] = useState(1);
  const [modalPageSize] = useState(500);
  const [modalTotalRows, setModalTotalRows] = useState(0);
  const [modalSearchQuery, setModalSearchQuery] = useState("-");

  const [searchBy, setSearchBy] = useState("UNIVERSAL");

  const [modalSuggestions, setModalSuggestions] = useState([]);

  const [salespersonList, setSalesPersonList] = useState(null);
  const [coordinatorList, setCoordinatorList] = useState(null);
  const [currencyList, setCurrencyList] = useState(null);

  const currentUserObject = JSON.parse(localStorage.getItem("currentUser"));
  const dynamicVatFromAPI = currentUserObject[0].vatp;

  const [rowToFocusId, setRowToFocusId] = useState(null);

  const callSalesPersonListAPI = () => {
    const currentDepartmentFromLocalStorage = localStorage.getItem(
      "currentSelectedDepartment"
    );

    let company_code_from_local_storage = localStorage.getItem("companyCode")
      ? localStorage.getItem("companyCode")
      : "-"; // only if user manually delete the key else condition would work , not even possible because if deleted then will be blocked at machine registration checking
    let apiPaths_from_local_storage = localStorage.getItem("apiPaths")
      ? JSON.parse(localStorage.getItem("apiPaths"))
      : "-";

    const apiUrl = `${apiPaths_from_local_storage[0].API_CONFIG}/api/MasterCount/${company_code_from_local_storage}/SALESPERSONLIST/-/${currentDepartmentFromLocalStorage}`;
    axios
      .get(apiUrl)
      .then((res) => {
        setSalesPersonList(res.data);
      })
      .catch((err) => {});
  };

  const callCoordinatorListAPI = () => {
    const currentDepartmentFromLocalStorage = localStorage.getItem(
      "currentSelectedDepartment"
    );

    let company_code_from_local_storage = localStorage.getItem("companyCode")
      ? localStorage.getItem("companyCode")
      : "-"; // only if user manually delete the key else condition would work , not even possible because if deleted then will be blocked at machine registration checking
    let apiPaths_from_local_storage = localStorage.getItem("apiPaths")
      ? JSON.parse(localStorage.getItem("apiPaths"))
      : "-";

    const apiUrl = `${apiPaths_from_local_storage[0].API_CONFIG}/api/MasterCount/${company_code_from_local_storage}/COORDINATORLIST/-/${currentDepartmentFromLocalStorage}`;
    axios
      .get(apiUrl)
      .then((res) => {
        setCoordinatorList([
          { EMP_ID: "", NAME: "GENERAL" }, // because from getalreadysend quote details - is coming
          ...res.data,
        ]);
      })
      .catch((err) => {});
  };

  useEffect(() => {
    callSalesPersonListAPI();
    callCoordinatorListAPI();
  }, []);

  useEffect(() => {
    if (rowToFocusId) {
      // ⭐️ Timeout is critical: it waits for the new row to render in the DOM
      const timer = setTimeout(() => {
        const targetInput = rowInputRefs.current[rowToFocusId];

        if (targetInput) {
          targetInput.focus();
          setRowToFocusId(null); // Reset after focus is successful
        }
      }, 150); // 150ms is safe for React to mount the new row

      return () => clearTimeout(timer);
    }
  }, [rowToFocusId]);

  const rowInputRefs = useRef({});

  const qtyInputRefsFromParent = useRef({});

  let company_code_from_local_storage = localStorage.getItem("companyCode")
    ? localStorage.getItem("companyCode")
    : "-";
  let apiPaths_from_local_storage = localStorage.getItem("apiPaths")
    ? JSON.parse(localStorage.getItem("apiPaths"))
    : "-";

  const [typedProjectNameFromChild, setTypedProjectNameFromChild] =
    useState("");

    const [typedEmailForQuotationFromChild, setTypedEmailForQuotationFromChild] =
    useState("");


    const [typedMobileForQuotationFromChild, setTypedMobileForQuotationFromChild] =
    useState("");

    

  const [typedAccountFromChild, setTypedAccountFromChild] = useState(null);

  const [typedCustomerNameFromChild, setTypedCustomerNameFromChild] =
    useState(null);

  const [typedSalesPersonId, setTypedSalesPersonId] = useState(null);

  const [typedCoordinatorId, setTypedCoordinatorId] = useState(null);

  const [isCallingTemplateListApi, setIsCallingTemplateListApi] =
    useState(false);

  const [isCallingAddToTemplateListApi, setIsCallingAddToTemplateListApi] =
    useState(false);
  const [showHideTemplateList, setShowHideTemplateList] = useState(false);
  const [termsTemplatelist, setTermsTemplatelist] = useState(null);
  const [showAddToTemplateForm, setShowAddToTemplateForm] = useState(false);
  const [templatename, setTemplateName] = useState("");
  const [selectedCustomerObject, setSelectedCustomerObject] = useState("");

  let sunrise_payment_terms = `1. Scope of Work : Supply Only 
  2. Validity: This quotation is valid for 15 days. 
 3. Delivery Time: Subjected to availability of stock at time of confirmation, else 6-8 weeks from the date of advance Payment
 4. Payment Terms: Cash
Payment should be made in favor of “SUNRISE OASIS LIGHTING LLC"
Bank Name: RAK BANK ; Account No: 0003-216105-061 
IBAN :AE800400000003216105061 

Warranty Terms
1. Manufacturer standard warranty on manufacturing defects under standard warranty conditions.
2. Warranty against the manufacturing defect from the date of invoice.
3. The warranty claim is subject to in house warranty only, for there modification or repair at the site will not cover the same and will be chargeable.
`;
  let initialPaymentString =
    company_code_from_local_storage?.trim().toUpperCase() === "SUNRISE"
      ? sunrise_payment_terms
      : "";

  const [paymentState, setPaymentState] = useState(initialPaymentString);

  const [alreadySentQuotationNumber, setAlreadySentQuotationNumber] =
    useState("");

  const [f2PopupViewToggle, setF2PopupViewToggle] = useState(false);
  const [currentF2ItemForSearchPopup, setCurrentF2ItemForSearchPopup] =
    useState(0);

  const [nextActionArrayInParent, setNextActionArrayInParent] = useState(null);

  const currentSelectedDepartment = localStorage.getItem(
    "currentSelectedDepartment"
  );

  const [quotationNumberOfThisLead, setQuotationNumberOfThisLead] =
    useState(null);

  const [discountValue, setDiscountValue] = useState(0);

  const loc = useLocation();
  const selectedLead = loc.state?.selectedLead ?? null; // confirmed since no editing here like in view lead no need to call single api to get lead details
  const previous_page_url_last_part = loc.state?.previous_page_url_last_part;
  console.log(
    "selectedLead in QuoteLead previous_page_url_last_part",
    selectedLead,
    previous_page_url_last_part
  );
  const { setShowBreadcrumbs } = useBreadcrumbs();
  const navigate = useNavigate();
  const apiRef = useGridApiRef();

  const [vat, setVat] = useState("vatApplied");

  const [selectedTab1, setSelectedTab1] = useState(0);
  const [selectedTab2, setSelectedTab2] = useState(0);
  const [productsInQuotationState, setProductsInQuotation] = useState(null);
  const [duplicateItemCodeSnackbar, setDuplicateItemCodeSnackbar] =
    useState(false);
  const [products, setProducts] = useState(productDetails);
  const [selectedRows, setSelectedRows] = useState([]);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [modalImage, setModalImage] = useState("");
  const [vatIncluded, setVatIncluded] = useState(false);
  const [vatValue, setVatValue] = useState("");
  const [productData, setProductData] = useState([]);
  const [selectedPromisedDate, setSelectedPromisedDate] = useState("");
  const [selectedFollowupDate, setSelectedFollowupDate] = useState("");
  const [currency, setCurrency] = useState(currencyList?.[0]?.curno || "-");
  const [currencyAmount, setCurrencyAmount] = useState("");
  const [isSubmittingForm, setIsSubmittingForm] = useState(false);
  const [currentProductEntryRowId, setCurrentProductEntryRowId] =
    useState(null);
  const [currentProductTyping, setCurrentProductTyping] = useState(null);
  const [openSubmitSnackbar, setOpenSubmitSnackbar] = useState(false);
  const [productEntries, setProductEntries] = useState([]);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [errorRow, setErrorRow] = useState(null);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [customerSubject, setCustomerSubject] = useState(null);
  const [customerTRN, setCustomerTRN] = useState(null);
  // const [customerType, setCustomerType] = useState("registered"); earlier like this but we want to check from api so put empty then update when api is called to get lead or quotation details
  const [customerType, setCustomerType] = useState(null);
  const [showPDFDialogBox, setShowPDFDialogBox] = useState(false);
  const [userDepartment, setUserDepartment] = useState(null);
  const [customerAddress, setCustomerAddress] = useState("");

  const [attentionInQuotation, setAttentionInQuotation] = useState("");
  const handleCustomerTypeChange = (newCustomerType) => {
    setCustomerType(newCustomerType);
  };
  // console.log("customerType:::", customerType);

  const getCurrencylist = () => {
    let company_code_from_local_storage = localStorage.getItem("companyCode")
      ? localStorage.getItem("companyCode")
      : "-";

    let API_PATHS = localStorage.getItem("apiPaths")
      ? JSON.parse(localStorage.getItem("apiPaths"))
      : "-";
    const BASE_URL = API_PATHS[0]?.API_CONFIG || "https://cubixweberp.com:213";
    axios
      .get(
        `${BASE_URL}/api/cpayscount/${company_code_from_local_storage}/currency/-/-`
      )
      .then((res) => {
        setCurrencyList(res.data);
        if (res.data) {
          setCurrency(res.data[0].curno);
        }
      })
      .catch((err) => {
        console.log("err ", err);
      });
  };

  const getDefaultLocation = async ()=>{
    let company_code_from_local_storage = localStorage.getItem("companyCode")
      ? localStorage.getItem("companyCode")
      : "-";

    let API_PATHS = localStorage.getItem("apiPaths")
      ? JSON.parse(localStorage.getItem("apiPaths"))
      : "-";
    const BASE_URL = API_PATHS[0]?.API_CONFIG || "https://cubixweberp.com:213";

    const deptRes = await fetch(
      `${BASE_URL}/api/CpaysCount/${company_code_from_local_storage}/DEPTLIST/-/-`,
    );

    const departmentList = await deptRes.json();
    console.log("departmentList ", departmentList)
    const currentDepartment = localStorage.getItem("currentSelectedDepartment") 
    const deptloc = departmentList?.find(
      (item) => item.deptno?.trim()?.toUpperCase() === currentDepartment?.trim()?.toUpperCase()
    )?.deptloc;
    if(deptloc){
      setDepartmentLocationForItemSearch(deptloc)
    }

  }

  useEffect(() => {
    setUserDepartment(localStorage.getItem("currentSelectedDepartment"));

    document.addEventListener("keydown", (e) => {
      if (e.key === "F2") {
        // Suppress default behaviour
        // e.g. F1 in Microsoft Edge on Windows usually opens Windows help
        e.preventDefault();
      }
    });

    document.addEventListener("keyup", (e) => {
      if (e.key === "F2") {
        // Handle the keyup event
        console.log("f2 pressed");
        if (e.target.name !== "organization") {
          setF2PopupViewToggle(true);
        }
      }
    });

    getCurrencylist();
    getDefaultLocation()
  }, []);

  useEffect(() => {
    console.log("vatValue ", vatValue);
  }, [vatValue]);

  // console.log("userDepartment", userDepartment);

  const noQuotationSendGetProductDetails = (selectedLeadFromUseEffect) => {
    // we have to put another condition what if lead item count is 0 ie no item is added at the time of lead so else if condition
    if (selectedLeadFromUseEffect && selectedLeadFromUseEffect.Cnt > 0) {
      console.log("selectedLeadFromUseEffect", selectedLeadFromUseEffect);
      const leadId = selectedLeadFromUseEffect.lead_id;
      const masterCountApiUrl = `${apiPaths_from_local_storage[0].API_CONFIG}/api/MasterCount/${company_code_from_local_storage}/LEADITEMS/${leadId}/${currentSelectedDepartment}`;

      console.log("Fetching lead items from:", masterCountApiUrl);

      axios
        .get(masterCountApiUrl)
        .then((response) => {
          let manipulatedArrayToSimulateLocalStorage = response.data.map(
            (item, index) => {
              return {
                id: new Date().getTime() + index,
                isSelectedItemCodeCorrect: true,
                itemCode: item.Prod_code,
                itemDescription: item.Prod_Description,
                itemUnit: item.Prod_Unit,
                itemQuantity: item.Prod_Qty,
                itemPrice: item.Prod_Price,
                itemAmount: item.Prod_Qty * item.Prod_Price,
                itemCurrentStock: "",
                itemImage: item.prod_imagepath,
                area_code: "",
                quotation_number: "",
                revision_number: "",
                itemCustRef: item.Cust_Ref ? item.Cust_Ref : "",
                isItemSampleNeeded: item.Have_Sample ? item.Have_Sample : "",
                itemImageBase64: item.Imagebase64,
                itemWebLink: item.WebLink,
                project_name_from_details:
                  selectedLeadFromUseEffect.lead_CampaignId,
                customer_name_from_details:
                  selectedLeadFromUseEffect.lead_organization,
                customer_account_from_details:
                  selectedLeadFromUseEffect.lead_account,

                  customer_email_from_details: selectedLeadFromUseEffect.lead_email ?? "",
                  customer_phone_from_details: selectedLeadFromUseEffect.lead_phone ?? "",
              };
            }
          );

          console.log(
            "manipulated array ",
            manipulatedArrayToSimulateLocalStorage
          );

          setProductsInQuotation(manipulatedArrayToSimulateLocalStorage);
        })
        .catch((error) => {
          console.error("Error fetching lead items:", error);
        });
    } else if (
      selectedLeadFromUseEffect &&
      selectedLeadFromUseEffect.Cnt === 0
    ) {
      let newlyCreatedObjectWhenZeroItems = {
        id: new Date().getTime(),
        isSelectedItemCodeCorrect: false,
        itemCode: "",
        itemDescription: "",
        itemUnit: "",
        itemQuantity: "",
        itemPrice: "",
        itemAmount: "",
        itemCurrentStock: "",
        itemImage: "",
        area_code: "",
        quotation_number: "",
        revision_number: "",
        itemCustRef: "",
        isItemSampleNeeded: "",
        itemImageBase64: "",
        itemWebLink: "",
        project_name_from_details: selectedLeadFromUseEffect.lead_CampaignId,
        customer_name_from_details: selectedLeadFromUseEffect.lead_organization,
        customer_account_from_details: selectedLeadFromUseEffect.lead_account,

        customer_email_from_details: selectedLeadFromUseEffect.lead_email ?? "",
                  customer_phone_from_details: selectedLeadFromUseEffect.lead_phone ?? "",
      };

      let newlyCreatedArrayWhenZeroItems = [newlyCreatedObjectWhenZeroItems];

      console.log(
        "newlyCreatedArrayWhenZeroItems ",
        newlyCreatedArrayWhenZeroItems
      );

      setProductsInQuotation(newlyCreatedArrayWhenZeroItems);
    }
  };

  const settingDataGotFromQuotationDetailsApiToScreen = (res)=>{

    console.log(
      "result of quotation details ",
      res.data,
      new Date().getTime()
    );

    let productListFromAlreadySendQuotation = res.data.map(
      (item, index) => {
        return {
          id: new Date().getTime() + index,
          isSelectedItemCodeCorrect: true,
          itemCode: item.so_icode,
          itemDescription: item.idesc,
          itemUnit: item.unit,
          itemQuantity: item.tr_qty2,
          itemPrice: item.so_fccost,
          itemAmount: item.tr_qty2 * item.so_fccost,
          itemCurrentStock: "",
          itemImage: item.Imagepath,
          itemImageBase64: item.Imagebase64,
          itemWebLink: item.WebLink,
          area_code: item.area_code,
          quotation_number: item.so_no,
          revision_number: item.jv_num,
          foot1: item.foot1,
          itemCustRef: item.Cust_Ref ? item.Cust_Ref : item.size,
          Have_Sample: item.Have_Sample,
          head1: item.head1,
          sample_quantity_requested: item.Sample_Qty,
          itemFoc: item.so_fccost === 0 ? "FOC" : "",
          so_disc: item.so_disc,
          so_doc: item.lead_campaignid,
          payment: item.payment,
          salespersonName: item.salespersonName,
          Lead_Phone: item.phone ?? "", // earlier item.Lead_Phone, now call phone ie from quotation details earlier Lead_Phone is from lead 
          Lead_email: item.email ?? "", // earlier item.Lead_email now email ie from quotation details earlier Lead_email is from lead 
          lead_CoordinatorName: item.lead_CoordinatorName,
          Coordinator: item.Coordinator,
          customer_name_from_details: item.accdesc,
          customer_account_from_details: item.cust_acc,
          project_name_from_details: item.so_doc,
          soUid1: item.soUid1,
          fc: item.fc,
          dynamicVatFromAPI: dynamicVatFromAPI,
          Address: item.Address,
          Sales_Person: item.Sales_Person,
          autoid: item.autoid,

          customer_email_from_details: item.email ?? "",
          customer_phone_from_details: item.phone ?? "",

        };
      }
    );

    if (productListFromAlreadySendQuotation) {
      if (productListFromAlreadySendQuotation.length > 0) {
        if (productListFromAlreadySendQuotation[0]?.autoid) {
          //confrim why passed account: "00000000" ? is it because if autoid > 0 it is surely walkin customer
          if (
            Number(productListFromAlreadySendQuotation[0]?.autoid) > 0
          ) {
            let customerObjectToPass = {
              account: "00000000",
              Custname: productListFromAlreadySendQuotation[0].accdesc,
              AutoId: Number(
                productListFromAlreadySendQuotation[0]?.autoid
              ),
            };
            setSelectedCustomerObject(customerObjectToPass);
          }
        }

        setAttentionInQuotation(
          productListFromAlreadySendQuotation[0].head1
            ? productListFromAlreadySendQuotation[0].head1
            : ""
        );
        setCustomerAddress(
          productListFromAlreadySendQuotation[0].Address
            ? productListFromAlreadySendQuotation[0].Address
            : ""
        );

        setTypedSalesPersonId(
          productListFromAlreadySendQuotation[0].Sales_Person
        );
        console.log(
          "parseFloat( productListFromAlreadySendQuotation[0].foot1 ) ",
          productListFromAlreadySendQuotation[0],
          parseFloat(productListFromAlreadySendQuotation[0].foot1)
        );

        setTypedCoordinatorId(
          productListFromAlreadySendQuotation[0].Coordinator
        );

        if (
          parseFloat(productListFromAlreadySendQuotation[0].foot1) > 0
        ) {
          setVat("vatApplied");
        } else {
          console.log("inside vatExempted");
          setVat("vatExempted");
        }

        if (productListFromAlreadySendQuotation[0].so_disc) {
          console.log(
            "productListFromAlreadySendQuotation[0].so_disc ",
            productListFromAlreadySendQuotation[0].so_disc
          );
          setDiscountValue(
            productListFromAlreadySendQuotation[0].so_disc
          );
        }

        if (productListFromAlreadySendQuotation[0].payment) {
          if (
            productListFromAlreadySendQuotation[0].payment?.length === 0
          ) {
            loadDefaultTemplate();
          } else {
            setPaymentState(
              productListFromAlreadySendQuotation[0].payment
            );
          }
        }
      }
    }

    setProductsInQuotation(productListFromAlreadySendQuotation);

    setProductsInQuotationAsFromApiForPDF(
      productListFromAlreadySendQuotation
    );

  }

  const getAlreadySendQuotation = async (quotationNumber) => {
    return new Promise((resolve, reject) => {
      let apiUrl = `${apiPaths_from_local_storage[0].API_CONFIG}/api/Proposal/${company_code_from_local_storage}/QUOTEDETAILS/${quotationNumber}/${currentSelectedDepartment}`;
      console.log("apiurl of get quotationdetails ", apiUrl);

      axios
        .get(apiUrl)
        .then((res) => {
          if (res.data) {

            settingDataGotFromQuotationDetailsApiToScreen(res)

           
          }
        })
        .catch((err) => {
          console.log("err ", err);
        });
    });
  };

  const checkIfLeadHasAlreadyQuotation = async (selectedLeadFromUseEffect) => {
    return new Promise((resolve, reject) => {
      let apiUrl = `${apiPaths_from_local_storage[0].API_CONFIG}/api/MasterCount/${company_code_from_local_storage}/GetProposalOfLead/${selectedLeadFromUseEffect.lead_id}/${currentSelectedDepartment}`;
      console.log("apiurl of check if already quotation done ", apiUrl);

      axios
        .get(apiUrl)
        .then((res) => {
          if (res.data) {
            if (res.data[0]) {
              if (res.data[0].Column1) {
                console.log("res Column1 not null", res.data);
                resolve(res.data[0].Column1);
              } else {
                console.log("res Column1 null", res.data);
                resolve(null);
              }
            }
          }
        })
        .catch((err) => {
          console.log("err ", err);
          reject(err);
        });
    });
  };

  const checkingForQuotation = async (selectedLeadFromUseEffect) => {
    console.log(
      "selectedLeadFromUseEffect Quotelead checkingForQuotation",
      selectedLeadFromUseEffect
    );
    try {
      let resultOfQuotationChecking = await checkIfLeadHasAlreadyQuotation(
        selectedLeadFromUseEffect
      );
      console.log("resultOfQuotationChecking ", resultOfQuotationChecking);
      setQuotationNumberOfThisLead(resultOfQuotationChecking);
      console.log("quotationNumberOfThisLead ", quotationNumberOfThisLead);
      if (resultOfQuotationChecking) {
        console.log("res Column1 not null", resultOfQuotationChecking);
        getAlreadySendQuotation(resultOfQuotationChecking);
        setAlreadySentQuotationNumber(resultOfQuotationChecking);
      } else {
        console.log("res Column1 null >>>>>>");
        noQuotationSendGetProductDetails(selectedLeadFromUseEffect);

        loadDefaultTemplate();

        let customerObjectToPass = {
          account: "00000000",
          Custname: selectedLeadFromUseEffect.lead_organization,
          AutoId: Number(selectedLeadFromUseEffect.autoid),
        };
        setSelectedCustomerObject(customerObjectToPass);

        setTypedSalesPersonId(selectedLead.lead_salesperson);
        setAttentionInQuotation(selectedLead.lead_primarycontact);
        setTypedCoordinatorId(selectedLead.lead_coordinator);
      }
    } catch (err) {
      console.log("res Column1 rejected reason", err);
    }
  };

  useEffect(() => {
    console.log(
      "inside useEffect Quotelead previous_page_url_last_part",
      selectedLead,
      previous_page_url_last_part
    );

    if (selectedLead) {
      // because view pdf will be invisible if we go to quotation pdf then come back and refresh the page
      // all this above checking above was done because from lad list also we can view this page so to show product list even if there is no quotation number
      // setQuotationNumberOfThisLead is used to show view pdf

      if (selectedLead.Prop_No) {
        console.log("second line");
        getAlreadySendQuotation(selectedLead.Prop_No);
        setAlreadySentQuotationNumber(selectedLead.Prop_No);
        setQuotationNumberOfThisLead(selectedLead.Prop_No);
      } else {
        console.log("fourth line");
        checkingForQuotation(selectedLead);
      }
      // } commented this check
    } else {
      if (selectedLead === null) {
        loadDefaultTemplate();
      }
    }
  }, [selectedLead]);

  const handleImageClick = (rowId) => {
    const selectedProduct = products.find((product) => product.id === rowId);
    if (selectedProduct.image) {
      setModalImage(selectedProduct.image); // Set the image to display.
      setOpenModal(true);
    } else {
      const fileInput = document.getElementById(`file-upload-${rowId}`);
      if (fileInput) {
        fileInput.click(); // Trigger file input dialog.
      }
    }
  };

  const handleImageUpload = (event, rowId) => {
    const file = event.target.files[0];
    if (file) {
      const imageUrl = URL.createObjectURL(file); // Generate a preview URL.
      setProducts((prev) =>
        prev.map((product) =>
          product.id === rowId ? { ...product, image: imageUrl } : product
        )
      );
    }
  };

  const handleTab1Change = (event, newValue) => {
    setSelectedTab1(newValue);
  };

  const handleTab2Change = (event, newValue) => {
    setSelectedTab2(newValue);
  };

  const handleRowSelection = (ids) => {
    setSelectedRows(ids);
  };

  const handleRedirect = () => {
    setShowBreadcrumbs(false);
    navigate("/qualifiedLeadsTable"); // Redirect to Qualified Leads
  };

  const handlePromisedDateChange = (event) => {
    setSelectedPromisedDate(event.target.value); // Update the state with the new date
  };

  const handleFollowupDateChange = (event) => {
    setSelectedFollowupDate(event.target.value); // Update the state with the new date
  };

  const location = useLocation();

  const isQuotationRoute = location.pathname.includes("quoteLead");

  // Handle toggle switch
  const handleToggle = (event) => {
    console.log(
      "event.target.checked handleToggle event, vat",
      event.target.checked,
      vat
    );

    if (vat === "vatApplied" || vat === "noVat") {
      console.log(
        "event.target.checked handleToggle if >>>++>>>",
        event.target.checked,
        vat
      );
    } else {
      console.log(
        "event.target.checked handleToggle else",
        event.target.checked
      );

      setVatIncluded(event.target.checked);

      if (event.target.checked) {
        console.log(
          "event.target.checked handleToggle else >>> again if productsInQuotationState",
          event.target.checked,
          productsInQuotationState,
          discountValue
        );

        if (discountValue) {
          setVatValue(
            ((productsInQuotationState
              ?.filter((item) => {
                if (
                  item.itemCustRef?.trim()?.toUpperCase() === "OPT" ||
                  item.itemCustRef?.trim()?.toUpperCase() === "OPTION"
                ) {
                  return false;
                } else {
                  return true;
                }
              })
              .reduce((acc, curr) => {
                return acc + curr.itemQuantity * curr.itemPrice;
              }, 0) -
              discountValue) *
              dynamicVatFromAPI) /
              100
          );
        } else {
          setVatValue(
            (productsInQuotationState
              ?.filter((item) => {
                if (
                  item.itemCustRef?.trim()?.toUpperCase() === "OPT" ||
                  item.itemCustRef?.trim()?.toUpperCase() === "OPTION"
                ) {
                  return false;
                } else {
                  return true;
                }
              })
              .reduce((acc, curr) => {
                return acc + curr.itemQuantity * curr.itemPrice;
              }, 0) *
              dynamicVatFromAPI) /
              100
          );
        }
      } else {
        console.log(
          "event.target.checked handleToggle else >>> again else",
          event.target.checked
        );

        setVatValue(0);
      }
    }
  };

  const handleCurrency = (event) => {
    setCurrency(event.target.value);
  };

  const handleCurrencyAmount = (event) => {
    setCurrencyAmount(event.target.value);
  };

  const theme = createTheme({
    typography: {
      fontFamily: `'Figtree', sans-serif`,
    },
  });

  const handleDownloadPDF = () => {
    const quotationElement = document.getElementById("quotation-content");

    html2canvas(quotationElement, { scale: 2 }).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", "a4");
      const imgWidth = 210;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;
      pdf.addImage(imgData, "PNG", 0, 10, imgWidth, imgHeight);
      pdf.save("quotation.pdf");
    });
  };

  // if customer  type is walkin autoid is mandatory without it should not save
  // check if autoid is got and saved into a field when calling noQuotationSendGetProductDetails function, if lead was created with a customer having autoid 

  const handleSaveQuotation = async () => {

    console.log(
      "productsInQuotationState inside handleSaveQuotation",
      productsInQuotationState,
      selectedLead
    );

    const validProducts = productsInQuotationState?.filter(
      (product) => product.itemCode && product.itemCode.trim() !== ""
    );

    if(validProducts?.length == 0){
      alert("Please enter atleast 1 item with code")
      return
    }

    const itemsWithoutItemUnit = validProducts?.filter(
      (product) => !product.itemUnit || product.itemUnit.trim() === ""
    );

    if(itemsWithoutItemUnit?.length > 0 ){
      alert("Cannot save items without unit")
      return
    }

    console.log("selectedCustomerObject ", selectedCustomerObject);

    if (customerType === "walkin") {
      if (
        selectedCustomerObject === "" ||
        selectedCustomerObject === null ||
        selectedCustomerObject === undefined
      ) {
        alert("please search and select walkin customer ");

        return;
      }
    }

    if (quotationNumberOfThisLead) {
      if (customerType === "registered") {
        if (typedAccountFromChild === "00000000") {
          alert("please search and select registered customer ");
          return;
        }
      } else {
        if (
          typedCustomerNameFromChild?.length == 0 ||
          (validProducts[0].autoid == "0" &&
            !selectedCustomerObject.AutoId)
        ) {
          alert("please choose walkin customer.");
          return;
        }
      }
    } else {
      if (selectedLead) {
        if (customerType === "registered") {
          if (typedAccountFromChild === "00000000") {
            alert("please search and select registered customer ");
            return;
          }
        } else {
          if (
            typedCustomerNameFromChild?.length === 0 ||
            (selectedLead.autoid === "0" && !selectedCustomerObject.AutoId)
          ) {
            alert("please choose walkin customer.."); // if this happens call cash customer list so it will call api if customer present select else add new customer
            fetchCashCustomerList(typedCustomerNameFromChild);
            setShowDropdown(true);

            return;
          }
        }
      } else {
        if (customerType === "registered") {
          if (typedAccountFromChild === "00000000") {
            alert("please search and select registered customer ");
            return;
          }
        } else {
          if (
            typedCustomerNameFromChild?.length === 0 ||
            !selectedCustomerObject.AutoId
          ) {
            alert("please choose walkin customer...");
            return;
          }
        }
      }
    }

    console.log("inside  handleSaveQuotation");

    if (
      validProducts?.filter(
        (item) => item.itemFoc != "FOC" && item.itemPrice == 0
      )?.length > 0
    ) {
      alert("Please enter price for Non FOC items");
      return;
    }

    if (
      validProducts?.filter(
        (item) => item.itemQuantity == 0 || item.itemQuantity == ""
      )?.length > 0
    ) {
      alert("Please enter qty for all items");
      return;
    }

    console.log("inside  handleSaveQuotation 2");

    

    if (canUserSeeThis("ZH") && typedProjectNameFromChild?.trim().length == 0) {
      alert("Project name is mandatory ");
      return;
    }

    // this curr.Lead_ID wont be called i think because in productsInQuotationState Lead_ID not set even when alreadySendQuotationDetails is called or noQuotationSendGetProductDetails

    const requestData = validProducts.map((product, index) => ({
      cmpcode: company_code_from_local_storage,
      opmode: quotationNumberOfThisLead ? "EDIT" : "SAVE",
      so_no: quotationNumberOfThisLead ? quotationNumberOfThisLead : "NEW",
      so_date: format(new Date(), "yyyy-MM-dd'T'hh:mm:ss"),
      Cust_Acc: typedAccountFromChild, // this field
      jv_num: quotationNumberOfThisLead ? product?.revision_number ?? "0" : "0", // confirm this is to send in jv_num
      comments: "",
      sale_man: quotationNumberOfThisLead
        ? typedSalesPersonId
        : selectedLead.lead_salesperson
        ? selectedLead.lead_salesperson
        : "",
      inv_no: quotationNumberOfThisLead
        ? customerType === "registered"
          ? "0"
          : selectedCustomerObject.AutoId
        : selectedCustomerObject.AutoId, // earlier "0" now pass autoid here
      so_status: "",
      // area_code: "AC1001",
      area_code: validProducts
        ? validProducts[0].area_code
          ? validProducts[0].area_code
          : "Draft"
        : "Draft", // Approval stage of
      so_ref: "",
      so_doc: typedProjectNameFromChild ? typedProjectNameFromChild : "", //productsInQuotationState[0].so_doc ? "" : "", // this field
      fc: currency,
      so_amount:
      validProducts
          ?.filter((item) => {
            if (
              item.itemCustRef?.trim()?.toUpperCase() === "OPT" ||
              item.itemCustRef?.trim()?.toUpperCase() === "OPTION"
            ) {
              return false;
            } else {
              return true;
            }
          })
          .reduce((acc, curr) => {
            if (curr.Lead_ID) {
              return acc + curr.Prod_Qty * curr.Prod_Price;
            } else {
              return acc + curr.itemQuantity * curr.itemPrice;
            }
          }, 0) -
        discountValue +
        vatValue +
        "", // pass every numberic inside string else error in backend eventhough saving api success it wont save item in backend number with large decimal
      so_fcamt: 0,
      so_fcrate: 1,
      so_disc: discountValue ? discountValue : 0,
      due_date: "2025-03-15T00:00:00", // dummy value
      so_fdisc: 0.0,
      accdesc: typedCustomerNameFromChild, // this field
      head1: quotationNumberOfThisLead
        ? attentionInQuotation
        : selectedLead.lead_primarycontact
        ? selectedLead.lead_primarycontact
        : validProducts[0]?.head1,
      subject: customerSubject ? customerSubject : "",
      foot1: vatValue ? vatValue + "" : 0 + "",
      payment: paymentState,
      delivery: typedEmailForQuotationFromChild ? typedEmailForQuotationFromChild :"", // i am now passing email earlier was blank 
      validity: typedMobileForQuotationFromChild ? typedMobileForQuotationFromChild :"", // phone number earlier was blank 
      deptno: currentSelectedDepartment,
      ESTI_NO: selectedLead.lead_id,
      quot_NO: Number(product.sample_quantity_requested), // pass here requested sample quantity
      ord_NO: 0,
      remarks: "",
      c1: quotationNumberOfThisLead
        ? typedCoordinatorId
        : selectedLead.lead_coordinator
        ? selectedLead.lead_coordinator
        : "",
      c2: customerTRN ? customerTRN : "-",
      c3: "", // project name pass here
      cash_customer: customerType === "registered" ? "No" : "Yes",
      cash_customer_company_address:
        customerType === "registered"
          ? ""
          : `${selectedLead?.lead_streetaddress || " "} ${
              selectedLead?.lead_territory || " "
            } ${selectedLead?.lead_country || " "} ${
              selectedLead?.lead_city || " "
            } ${selectedLead?.lead_appartment || " "} ${
              selectedLead?.lead_area || " "
            } ${selectedLead?.lead_location || " "}`,
      cash_customer_company_name:
        customerType === "registered"
          ? ""
          : selectedLead?.lead_organization
          ? selectedLead?.lead_organization
          : "",
      cash_customer_company_phone_number:
        customerType === "registered"
          ? ""
          : selectedLead?.lead_phone
          ? selectedLead?.lead_phone
          : "",

      // Slno: "1",
      Slno: index + 1,
      // code: "PRD98765",
      code: product.Prod_code ? product.Prod_code : product.itemCode,
      // description: "Product Description Here",
      description: product.Prod_code
        ? product.Prod_Description
        : product.itemDescription,
      locn: "",
      // unit: "PCS",
      unit: product.Prod_code ? product.Prod_Unit : product.itemUnit,

      qty: Number(product.Prod_code ? product.Prod_Qty : product.itemQuantity),
      unit_price: product.Prod_code ? product.Prod_Price : product.itemPrice,
      "disc%": 0,
      BlkPrice: 0,
      Amount:
      validProducts
          ?.filter((item) => {
            if (
              item.itemCustRef?.trim()?.toUpperCase() === "OPT" ||
              item.itemCustRef?.trim()?.toUpperCase() === "OPTION"
            ) {
              return false;
            } else {
              return true;
            }
          })
          .reduce((acc, curr) => {
            if (curr.Lead_ID) {
              return acc + curr.Prod_Qty * curr.Prod_Price;
            } else {
              return acc + curr.itemQuantity * curr.itemPrice;
            }
          }, 0) -
        discountValue +
        vatValue +
        "", // now pass so_amount here also as manoj sir said because in backend this field not considered
      x: "",
      cntrl: product.soUid1 ? product.soUid1 : "",
      fraction: 1,
      "vat%": vatValue ? dynamicVatFromAPI : 0,
      Vatamt: vatValue ? vatValue + "" : 0 + "",
      total:
      validProducts
          ?.filter((item) => {
            if (
              item.itemCustRef?.trim()?.toUpperCase() === "OPT" ||
              item.itemCustRef?.trim()?.toUpperCase() === "OPTION"
            ) {
              return false;
            } else {
              return true;
            }
          })
          .reduce((acc, curr) => {
            if (curr.Lead_ID) {
              return acc + curr.Prod_Qty * curr.Prod_Price;
            } else {
              return acc + curr.itemQuantity * curr.itemPrice;
            }
          }, 0) -
        discountValue +
        vatValue +
        "", // now pass so_amount here also as manoj sir said because in backend this field not considered
      oem: "For Approval", // pass "For Approval if quot_No greater than 0 also when retrieving if here rejected comes then also we can edit quot_No field ie sample quantity edit quot_No if here blank or Rejected comes"
      UPrice_VIncl: 0 + "", //
      item_Remarks: product.itemCustRef ? product.itemCustRef : "", // customer remark here
      address: quotationNumberOfThisLead
        ? customerAddress
        : [
            selectedLead?.lead_appartment,
            selectedLead?.lead_streetaddress,
            selectedLead?.lead_city,
            selectedLead?.lead_area,
            selectedLead?.lead_location,
            selectedLead?.lead_territory,
            selectedLead?.lead_country,
            selectedLead?.lead_email,
            selectedLead?.lead_phone
              ? "phone : " + selectedLead?.lead_phone
              : "",
          ]
            .filter((field) => field && field.trim() !== "")
            .join(", "),
    }));

    console.log(" requestData save quotation ", requestData);
    const apiUrl = `${apiPaths_from_local_storage[0].API_CONFIG}/api/Proposalcrm`; // Replace with your API URL

    try {
      console.log("Request Data:", requestData); // Debug the request payload
      const response = await axios.post(apiUrl, requestData, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      console.log("API Response:", response.data);

      // alert("Order Saved Successfully");

      popupPDF();
    } catch (error) {
      console.error("Error Sending API:", error);
      alert("Failed to Save Quotation");
    }
  };

  const handleSaveQuotationNew = async () => {

    const validProducts = productsInQuotationState?.filter(
      (product) => product.itemCode && product.itemCode.trim() !== ""
    );

    if(validProducts?.length == 0){
      alert("Please enter atleast 1 item with code")
      return
    }

    const itemsWithoutItemUnit = validProducts?.filter(
      (product) => !product.itemUnit || product.itemUnit.trim() === ""
    );

    if(itemsWithoutItemUnit?.length > 0 ){
      alert("Cannot save items without unit")
      return
    }

    if (typedAccountFromChild == undefined) {
      alert("Customer account details missing");
      return;
    }

    // if (selectedCustomerObject.sale_man === undefined) {
    //   alert("Salesman details missing")
    //   return
    // }

    // if (typedProjectNameFromChild === undefined) {
    //   alert("Project details missing")
    //   return
    // }

    if (typedCustomerNameFromChild === undefined) {
      alert("Customer name details missing");
      return;
    }

    // if (customerSubject === null) {
    //   alert("Customer subject details missing")
    //   return
    // }

    // if nothing entered undefined can come as value in field so check that also
    if (customerType === "registered") {
      if (typedAccountFromChild === "00000000") {
        alert("please search and select registered customer ");
        return;
      }
    } else {
      if (
        typedCustomerNameFromChild?.length === 0 ||
        !selectedCustomerObject.AutoId
      ) {
        alert("please choose walkin customer....");
        return;
      }
    }

    console.log("inside  handleSaveQuotation");

    if (validProducts == null) {
      alert("Please add atleast one product");
      return;
    }

    if (
      validProducts?.filter(
        (item) => item.itemFoc != "FOC" && item.itemPrice == 0
      )?.length > 0
    ) {
      alert("Please enter price for Non FOC items");
      return;
    }

    if (
      validProducts?.filter(
        (item) => item.itemQuantity == 0 || item.itemQuantity == ""
      )?.length > 0
    ) {
      alert("Please enter qty for all items");
      return;
    }

    console.log("inside  handleSaveQuotation 2");

    console.log(
      "productsInQuotationState inside handleSaveQuotation",
      productsInQuotationState,
      selectedLead
    );

    if (canUserSeeThis("ZH") && typedProjectNameFromChild?.trim().length == 0) {
      alert("Project name is mandatory ");
      return;
    }

    if (!typedSalesPersonId || typedSalesPersonId.toString().trim().length === 0) {
      alert("Please select salesperson");
      return;
    }

    const requestData = validProducts.map((product, index) => ({
      cmpcode: company_code_from_local_storage, //no problem
      opmode: quotationNumberOfThisLead ? "EDIT" : "SAVE",
      so_no: quotationNumberOfThisLead ? quotationNumberOfThisLead : "NEW", //no problem
      so_date: format(new Date(), "yyyy-MM-dd'T'hh:mm:ss"), //no problem
      Cust_Acc: typedAccountFromChild, // problem undefined can come
      jv_num: "0", //no problem
      comments: "", //no problem
      sale_man: typedSalesPersonId, // problem undefined can come
      inv_no:
        customerType === "registered"
          ? "0"
          : selectedCustomerObject.AutoId
          ? selectedCustomerObject.AutoId
          : "0", // no problem here pass auto id if walkin customer
      so_status: "", // no problem
      // area_code: "AC1001",
      area_code: validProducts
        ? validProducts[0].area_code
          ? validProducts[0].area_code
          : "Draft"
        : "Draft", // Approval stage of // no problem
      so_ref: "", // no problem
      so_doc: typedProjectNameFromChild ? typedProjectNameFromChild : "", // problem undefined come , productsInQuotationState[0].so_doc ? "" : "", // this field
      fc: currency, // no problem
      so_amount:
      validProducts
          ?.filter((item) => {
            if (
              item.itemCustRef?.trim()?.toUpperCase() === "OPT" ||
              item.itemCustRef?.trim()?.toUpperCase() === "OPTION"
            ) {
              return false;
            } else {
              return true;
            }
          })
          .reduce((acc, curr) => {
            if (curr.Lead_ID) {
              return acc + curr.Prod_Qty * curr.Prod_Price;
            } else {
              return acc + curr.itemQuantity * curr.itemPrice;
            }
          }, 0) -
        discountValue +
        vatValue +
        "", //no problem , pass every numberic inside string else error in backend eventhough saving api success it wont save item in backend number with large decimal
      so_fcamt: 0, // check why 0
      so_fcrate: 1, // check why 1
      so_disc: discountValue ? discountValue : 0, // no problem
      due_date: "2025-03-15T00:00:00", //check why this dummy value
      so_fdisc: 0.0, // no problem
      accdesc: typedCustomerNameFromChild, // undefined can come this field
      head1: attentionInQuotation, // no problem
      subject: customerSubject ? customerSubject : "", // null can come problem
      foot1: vatValue ? vatValue + "" : 0 + "", // no problem
      payment: paymentState, // no prblem
      delivery: typedEmailForQuotationFromChild ? typedEmailForQuotationFromChild :"", // i am now passing email earlier was blank
      validity: typedMobileForQuotationFromChild ? typedMobileForQuotationFromChild :"", // phone number earlier was blank
      deptno: currentSelectedDepartment, // no prblem
      ESTI_NO: "0", // no prblem
      quot_NO: isNaN(Number(product.sample_quantity_requested))
        ? 0
        : Number(product.sample_quantity_requested), //problem NaN can come pass here requested sample quantity
      ord_NO: 0, // no problem
      remarks: "", // no problem
      c1: typedCoordinatorId, // selectedLead.lead_coordinator // no problem
      c2: customerTRN ? customerTRN : "-", // no problem
      c3: "", // project name pass here // no problem
      cash_customer: customerType === "registered" ? "No" : "Yes", // no problem
      cash_customer_company_address: customerType === "registered" ? "" : ``, // no problem
      cash_customer_company_name: "", // no problem
      cash_customer_company_phone_number: "", // no problem

      // Slno: "1",
      Slno: index + 1, // no problem
      // code: "PRD98765",
      code: product.Prod_code ? product.Prod_code : product.itemCode, // space comes infront of code  it is from api i think , no problem
      // description: "Product Description Here",
      description: product.Prod_code
        ? product.Prod_Description
        : product.itemDescription, // no problem
      locn: "", // no problem
      // unit: "PCS",
      unit: product.Prod_code ? product.Prod_Unit : product.itemUnit, // no problem

      qty: Number(product.Prod_code ? product.Prod_Qty : product.itemQuantity), // no problem
      unit_price: product.Prod_code ? product.Prod_Price : product.itemPrice, // no problem
      "disc%": 0, // no problem
      BlkPrice: 0, // chek if 0 passing ok earlier passed 950.5 as dummy
      Amount:
      validProducts
          ?.filter((item) => {
            if (
              item.itemCustRef?.trim()?.toUpperCase() === "OPT" ||
              item.itemCustRef?.trim()?.toUpperCase() === "OPTION"
            ) {
              return false;
            } else {
              return true;
            }
          })
          .reduce((acc, curr) => {
            if (curr.Lead_ID) {
              return acc + curr.Prod_Qty * curr.Prod_Price;
            } else {
              return acc + curr.itemQuantity * curr.itemPrice;
            }
          }, 0) -
        discountValue +
        vatValue +
        "", // no problem, now pass so_amount here also as manoj sir said because in backend this field not considered
      x: "", // no problem
      cntrl: "", // no problem
      fraction: 1, // no problem
      "vat%": vatValue ? dynamicVatFromAPI : 0, // no problem
      Vatamt: vatValue ? vatValue + "" : 0 + "", // no problem
      total:
      validProducts
          ?.filter((item) => {
            if (
              item.itemCustRef?.trim()?.toUpperCase() === "OPT" ||
              item.itemCustRef?.trim()?.toUpperCase() === "OPTION"
            ) {
              return false;
            } else {
              return true;
            }
          })
          .reduce((acc, curr) => {
            if (curr.Lead_ID) {
              return acc + curr.Prod_Qty * curr.Prod_Price;
            } else {
              return acc + curr.itemQuantity * curr.itemPrice;
            }
          }, 0) -
        discountValue +
        vatValue +
        "", // // no problem  now pass so_amount here also as manoj sir said because in backend this field not considered
      oem: "For Approval", // check why this  pass "For Approval if quot_No greater than 0 also when retrieving if here rejected comes then also we can edit quot_No field ie sample quantity edit quot_No if here blank or Rejected comes"
      UPrice_VIncl: 0 + "", // check why this 105.263 + "" earlier passed like this
      item_Remarks: product.itemCustRef ? product.itemCustRef : "", // customer remark here no problem
      address: customerAddress,
    }));

    console.log(" requestData save quotation ", requestData);

    

    const apiUrl = `${apiPaths_from_local_storage[0].API_CONFIG}/api/Proposalcrm`; // Replace with your API URL

    try {
      console.log("Request Data:", requestData); // Debug the request payload

      const response = await axios.post(apiUrl, requestData, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      console.log("API Response:", response.data);
      // alert("Order Saved Successfully");

      clearLocalStorge();
      popupPDF();
    } catch (error) {
      console.error("Error Sending API:", error);
      alert("Failed to Save Quotation");
    }
  };

  const popupPDF = () => {
    setShowPDFDialogBox(true);
  };

  const navigateToPDF = () => {
    // send api , if success open popup for view in pdf ? and then navigate to pdf

    console.log(
      "selectedLead inside navigate to pdf --->>> productsInQuotationAsFromApiForPDF",
      selectedLead,
      productsInQuotationAsFromApiForPDF
    );

    // don't confuse this selectedLead just used this variable name , from quotation list item is sent here also in the same name even if there is no lead id
    // so else condition wont be reached i think
    if (selectedLead) {
      console.log("selectedLead inside navigate to pdf --->>>selectedLead");
      navigate("/quotationPage", {
        state: {
          selectedLead,
          productsInQuotationFromAPI: productsInQuotationAsFromApiForPDF,
          vatValue,
          alreadySentQuotationNumber,
          discountValue,
        },
      });
    } else {
      console.log("selectedLead pdf navigation --->>>else");

      navigate("/quotationPage");
    }
  };

  const onQuotationList = () => {
    navigate("/quotationsListViewFull");
  };

  const defaultRow = {
    id: Date.now(),
    itemCode: "",
    itemDescription: "",
    itemUnit: "",
    itemCurrentStock: "",
    itemQuantity: "",
    itemPrice: "",
    itemAmount: "",
    isSelectedItemCodeCorrect: false,
  };

  const handleAddRow = useCallback(
    (e, selectedRows) => {
      e.preventDefault();

      // 1. Check if an empty row already exists
      const emptyRow = productsInQuotationState?.find(
        (row) => !row.itemCode || row.itemCode.trim() === ""
      );

      if (emptyRow) {
        // ⭐️ If an empty row exists, don't create a new one, just focus it
        setRowToFocusId(emptyRow.id);
        return; // Stop execution here
      }

      console.log("handle add row clicked in quotelead", selectedRows);

      const newRowId = Date.now();

      // Create the new row object
      const newRow = {
        id: newRowId,
        itemCode: "",
        itemDescription: "",
        itemImage: "",
        itemImageBase64: "",
        itemWebLink: "",
        itemUnit: "",
        itemCurrentStock: "",
        itemQuantity: "",
        itemPrice: "",
        itemAmount: "",
        isSelectedItemCodeCorrect: false,
        itemCustRef: "",
        isItemSampleNeeded: "no",
        itemFoc: "",
      };

      // Check if we have existing products
      if (productsInQuotationState && productsInQuotationState.length > 0) {
        if (selectedRows?.length > 0) {
          console.log("selected rows > 0", selectedRows);
          // Insert new row after the first selected row
          const insertIndex = selectedRows[0];
          const newArrayToSplice = [
            ...productsInQuotationState.slice(0, insertIndex),
            newRow,
            ...productsInQuotationState.slice(insertIndex),
          ];
          console.log("newArray at specified position >>", newArrayToSplice);
          setProductsInQuotation(newArrayToSplice);
        } else {
          console.log("No rows selected, adding to end");
          // Add to the end of the array
          setProductsInQuotation((prevEntries) => [...prevEntries, newRow]);
        }
      } else {
        console.log("No existing products, creating first row");
        // Initialize with first row
        setProductsInQuotation([newRow]);
      }

      rowInputRefs.current[newRowId] = React.createRef();

      setRowToFocusId(newRowId);
    },
    [productsInQuotationState]
  );

  useEffect(() => {
    const handleKeyDown = (e) => {
      // Option+A (Mac) or Alt+A (Windows)

      console.log(
        "keys pressed is alt pressed then another key clicked",
        e.altKey,
        e.code
      );
      if (e.altKey && e.code === "KeyA") {
        e.preventDefault();
        handleAddRow(e);
      }
    };

    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [handleAddRow]); // ✅ handleAddRow is defined in this file so no prop issue

  const handleInputChange = (id, field, value) => {
    setCurrentProductEntryRowId(id);

    console.log(
      "handleInputChange row id productsInQuotationState",
      id,
      field,
      productsInQuotationState,
      value
    );

    // Set the current value being typed
    setCurrentProductTyping(value);

    if (field === "itemCode") {
      console.log("itemcode is set");
      fetchItemDetails(value, id); // Call your fetch function for item details
    }

    // Update the productEntries state with the new value
    let newArray = productsInQuotationState?.map((item) => {

      // this item.Lead_ID wont be called i think because in productsInQuotationState Lead_ID not set even when alreadySendQuotationDetails is called or noQuotationSendGetProductDetails
      if (item.Lead_ID) {
        if (item.Prod_code === id) {
          console.log("item.Prod_code === id", item.Prod_code, id);

          return {
            ...item,
            [field]: value,
            ...(field === "itemCode" && { isSelectedItemCodeCorrect: false }), // Set isSelectedItemCodeCorrect to false when itemCode changes
          };
        }
        return item;
      } else {
        if (item.id === id) {
          return {
            ...item,
            [field]: value,
            ...(field === "itemCode" && { isSelectedItemCodeCorrect: false }), // Set isSelectedItemCodeCorrect to false when itemCode changes
          };
        }
        return item;
      }
    });

    // Set the updated productEntries array to state
    setProductsInQuotation(newArray);
  };

  const fetchItemDetails = async (itemCode, rowId) => {
    // 1. Clear any existing timer from the previous keystroke
    if (debounceTimer.current) {
      clearTimeout(debounceTimer.current);
    }

    if (!itemCode || itemCode.trim() === "") {
      setProductData([]);
      return;
    }

    console.log(`Fetching details for Item Code: ${itemCode}`); // Log item code before fetching
    if (!itemCode) return;

    debounceTimer.current = setTimeout(async () => {
      try {
        const formattedQuery = itemCode.replace(/\//g, "%2F");

        const currentDepartmentFromLocalStorage = localStorage.getItem(
          "currentSelectedDepartment"
        );

       

        let company_code_from_local_storage = localStorage.getItem(
          "companyCode"
        )
          ? localStorage.getItem("companyCode")
          : "-"; // only if user manually delete the key else condition would work , not even possible because if deleted then will be blocked at machine registration checking
        let apiPaths_from_local_storage = localStorage.getItem("apiPaths")
          ? JSON.parse(localStorage.getItem("apiPaths"))
          : "-";

        let page = 1;

        let PAGE_SIZE = 50;

        let searchBy = "UNIVERSAL";

        const url = `${apiPaths_from_local_storage[0].API_CONFIG}/api/CRMStocksubList/${company_code_from_local_storage}/${searchBy}/${formattedQuery}/${departmentLocationForItemSearch}/-/${page}/${PAGE_SIZE}`;

        const response = await fetch(url);

        console.log("API response status:", response.status); // Log API response status

        const data = await response.json();
        console.log("API response data:", data); // Log response data
        setProductData(data);
      } catch (error) {
        console.error("Error fetching item details:", error);
      }
    }, 500); // Delay API call to avoid excessive requests
  };

  const selectProduct = (setProductCode) => {
    console.log("code of select product", setProductCode);

    const isDuplicate = productEntries.some(
      (product) => product.itemCode === setProductCode
    );
    if (isDuplicate) {
      // alert('this item already exists')
      setDuplicateItemCodeSnackbar(true);

      return;
    }

    const selectedProduct = productData.find(
      (product) => product.Code === setProductCode
    );

    if (selectedProduct) {
      setProductsInQuotation((prevEntries) =>
        prevEntries.map((entry) =>
          entry.id === currentProductEntryRowId
            ? {
                ...entry,
                itemCode: selectedProduct.Code,
                itemDescription: selectedProduct.Description,
                itemImage: selectedProduct.Imagepath,
                // itemUnit: selectedProduct.unit,
                itemUnit: selectedProduct.Unit,
                itemCurrentStock: selectedProduct.Stick, // Adjust according to your product data
                itemPrice: selectedProduct.SelPrice, // Adjust according to your product data
                itemAmount: selectedProduct.SelPrice * entry.itemQuantity, // Example calculation
                isSelectedItemCodeCorrect: true, // Example calculation
              }
            : entry
        )
      );
    }
    setIsDropdownOpen(false);
    setProductData(null);
  };

  const handleCloseSubmitSnackbar = () => {
    setOpenSubmitSnackbar(false);
    setDuplicateItemCodeSnackbar(false);
  };

  useEffect(() => {
    console.log("productsInQuotationState", productsInQuotationState);

    if (productsInQuotationState) {
      console.log(
        "productsInQuotationState before setting to local",
        productsInQuotationState
      );

      const itemCodeInProducts = productsInQuotationState?.map(
        (itemcodeProd) => itemcodeProd.itemCode
      );
      // console.log("itemCodeInProducts:", itemCodeInProducts);

      // Check if any item has isSelectedItemCodeCorrect as false
      const hasIncorrectItemCode = productsInQuotationState?.some(
        (item) => !item.isSelectedItemCodeCorrect
      );

      if (hasIncorrectItemCode) {
        setIsSubmittingForm(false);
      }

      if (vat === "vatApplied") {
        setVatValue(
          (productsInQuotationState
            ?.filter((item) => {
              if (
                item.itemCustRef?.trim()?.toUpperCase() === "OPT" ||
                item.itemCustRef?.trim()?.toUpperCase() === "OPTION"
              ) {
                return false;
              } else {
                return true;
              }
            })
            .reduce((acc, curr) => {
              if (curr.Lead_ID) {
                return acc + curr.Prod_Qty * curr.Prod_Price;
              } else {
                return acc + curr.itemQuantity * curr.itemPrice;
              }
            }, 0) -
            discountValue) *
            Number(dynamicVatFromAPI / 100)
        );
      } else if (vat === "noVat") {
        setVatValue(0);
      } else if (vat === "vatExempted") {
        setVatValue(0);
      } else if (vat === "outOfScope") {
        setVatValue(0);
      } else {
        console.warn("Unexpected vat value:", vat);
      }
    }
  }, [productsInQuotationState]);

  useEffect(() => {
    if (typedProjectNameFromChild) {
      localStorage.setItem(
        "quotation_typedProjectNameFromChild",
        JSON.stringify(typedProjectNameFromChild)
      );
      return;
    }
  }, [typedProjectNameFromChild]);

  useEffect(() => {
    if (customerType) {
      localStorage.setItem(
        "quotation_customerType",
        JSON.stringify(customerType?.trim())
      );
    }
  }, [customerType]);

  useEffect(() => {
    console.log("vat:in quotelead", vat);

    if (vat === "vatApplied") {
      setVatValue(
        ((productsInQuotationState
          ?.filter((item) => {
            if (
              item.itemCustRef?.trim()?.toUpperCase() === "OPT" ||
              item.itemCustRef?.trim()?.toUpperCase() === "OPTION"
            ) {
              return false;
            } else {
              return true;
            }
          })
          .reduce((acc, curr) => {
            if (curr.Lead_ID) {
              return (acc = acc + curr.Prod_Qty * curr.Prod_Price);
            } else {
              return (acc = acc + curr.itemQuantity * curr.itemPrice);
            }
          }, 0) -
          discountValue) *
          dynamicVatFromAPI) /
          100
      );
      setVatIncluded(true);
    } else if (vat === "noVat") {
      setVatValue(0);
      setVatIncluded(false);
    } else if (vat === "vatExempted") {
      setVatValue(0);
      setVatIncluded(false);
    } else if (vat === "outOfScope") {
      setVatValue(0);
      setVatIncluded(false);
    } else {
    }
  }, [vat]);

  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };

  const handleDeleteSelected = (e) => {
    e.preventDefault();
    console.log("productToDelete::", e.target.value);

    const remainingRows = productEntries.filter(
      (entry) => !selectedRows.includes(entry.id)
    );

    // Ensure at least one row exists
    if (remainingRows.length === 0) {
      remainingRows.push({ ...defaultRow, id: Date.now() });
    }

    setProductEntries(remainingRows);
    setSelectedRows([]);
  };

  const productEntryInAllEntries = (productEntryTimeline) => {
    console.log("productEntryTimeline from all entries:", productEntryTimeline);

    // Ensure productEntryTimeline has data and extract the first entry
    const productFormData =
      productEntryTimeline && productEntryTimeline[0]
        ? productEntryTimeline[0]
        : {};

    console.log("productFormData:", productFormData);

    const isProductAdded = !!(
      productFormData.itemCode ||
      productFormData.itemDescription ||
      productFormData.itemUnit ||
      productFormData.itemCurrentStock ||
      productFormData.itemQuantity ||
      productFormData.itemPrice ||
      productFormData.itemAmount
    );

    console.log("isProductAdded ::  :", isProductAdded);

    // setFormData((prevFormData) => ({
    //   ...prevFormData,
    //   isItemAdded: isProductAdded,
    //   itemCode: productFormData.itemCode || "",
    //   itemDescription: productFormData.itemDescription || "",
    //   itemUnit: productFormData.itemUnit || "",
    //   itemCurrentStock: productFormData.itemCurrentStock || "",
    //   itemQuantity: productFormData.itemQuantity || "",
    //   itemPrice: productFormData.itemPrice || "",
    //   itemAmount: productFormData.itemAmount || "",
    // }));
  };

  useEffect(() => {
    console.log(
      "productsInQuotation :",
      productsInQuotationState,
      currentProductEntryRowId
    );
  }, [productsInQuotationState, currentProductEntryRowId]);

  useEffect(() => {
    console.log("currentProductEntryRowId", currentProductEntryRowId);
  }, [currentProductEntryRowId]);

  const sendForApprovalClicked = () => {
    let newArray = productsInQuotationState?.map((item) => {
      return { ...item, area_code: "For Approval" };
    });

    // Set the updated productEntries array to state
    setProductsInQuotation(newArray);
  };

  const giveNextActionArrayToParent = (nextActionArray) => {
    setNextActionArrayInParent(nextActionArray);
  };

  useEffect(() => {
    if (discountValue) {
      if (vat === "vatApplied") {
        setVatValue(
          (productsInQuotationState
            ?.filter((item) => {
              if (
                item.itemCustRef?.trim()?.toUpperCase() === "OPT" ||
                item.itemCustRef?.trim()?.toUpperCase() === "OPTION"
              ) {
                return false;
              } else {
                return true;
              }
            })
            .reduce((acc, curr) => {
              if (curr.Lead_ID) {
                return acc + curr.Prod_Qty * curr.Prod_Price;
              } else {
                return acc + curr.itemQuantity * curr.itemPrice;
              }
            }, 0) -
            discountValue) *
            Number(dynamicVatFromAPI / 100)
        );
      } else {
        setVatValue(
          (productsInQuotationState
            ?.filter((item) => {
              if (
                item.itemCustRef?.trim()?.toUpperCase() === "OPT" ||
                item.itemCustRef?.trim()?.toUpperCase() === "OPTION"
              ) {
                return false;
              } else {
                return true;
              }
            })
            .reduce((acc, curr) => {
              if (curr.Lead_ID) {
                return acc + curr.Prod_Qty * curr.Prod_Price;
              } else {
                return acc + curr.itemQuantity * curr.itemPrice;
              }
            }, 0) -
            discountValue) *
            0
        );
      }
    }
  }, [discountValue]);

  const callApisAgainInQuoteLead = () => {
    checkingForQuotation(selectedLead);
  };

  // Delete selected rows
  const deleteSelectedRows = (selectedRows) => {
    const updatedEntries = productsInQuotationState.filter(
      (_, index) => !selectedRows.includes(index)
    );
    setProductsInQuotation(updatedEntries);
    setSelectedRows([]);
  };

  const markFOCForSelectedRows = (selectedRows) => {
    const updatedEntries = productsInQuotationState.map((item, index) => {
      if (selectedRows.includes(index)) {
        return {
          ...item,
          itemFoc: item.itemFoc === "FOC" ? "" : "FOC",
          itemPrice: 0,
        };
      }
      return item;
    });
    setProductsInQuotation(updatedEntries);
    setSelectedRows([]);
  };

  const markSubstituteForSelectedRows = (selectedRows) => {
    const updatedEntries = productsInQuotationState.map((item, index) => {
      if (selectedRows.includes(index)) {
        return {
          ...item,
          itemCustRef: item.itemCustRef === "OPT" ? "" : "OPT",
        };
      }
      return item;
    });
    setProductsInQuotation(updatedEntries);
    setSelectedRows([]);
  };

  const updatePaymentTerms = (e) => {
    console.log(" typed textarea ", e.target.value);

    setPaymentState(e.target.value);
  };

  const getTemplatelist = () => {
    setIsCallingTemplateListApi(true);

    let apiUrl = `${apiPaths_from_local_storage[0].API_CONFIG}/api/Proposal/${company_code_from_local_storage}/TERMSTEMPLATELIST/-/-`;

    axios
      .get(apiUrl)
      .then((res) => {
        setIsCallingTemplateListApi(false);

        setTermsTemplatelist(res.data);
      })
      .catch((err) => {
        setIsCallingTemplateListApi(false);

        setTermsTemplatelist(null);
      });
  };

  const getTermsTemplateDetails = (itemCodeFromClick) => {
    let apiUrl = `${apiPaths_from_local_storage[0].API_CONFIG}/api/Proposal/${company_code_from_local_storage}/TERMSTEMPLATESINGLE/${itemCodeFromClick}/-`;

    axios
      .get(apiUrl)
      .then((res) => {
        let newArray = res.data.filter((itemFilter) => {
          return itemCodeFromClick === itemFilter.mastercode;
        });

        setPaymentState(newArray[0].description ? newArray[0].description : "");

        setShowHideTemplateList(false);
      })
      .catch((err) => {});
  };
  useEffect(() => {
    if (showHideTemplateList) {
      getTemplatelist();
    } else {
      setTermsTemplatelist(null);
    }
  }, [showHideTemplateList]);

  // Load default template only on initial mount
  const loadDefaultTemplate = async () => {
    try {
      const apiUrl = `${apiPaths_from_local_storage[0].API_CONFIG}/api/Proposal/${company_code_from_local_storage}/TERMSTEMPLATELIST/-/-`;
      const response = await axios.get(apiUrl);

      const defaultTemplate = response.data?.find(
        (item) => item.mastercode?.trim().toLowerCase() === "default"
      );

      if (defaultTemplate) {
        getTermsTemplateDetails(defaultTemplate.mastercode);
      }
    } catch (error) {
      console.error("Error loading default template:", error);
    }
  };

  const saveToTermsTemplate = () => {
    if (templatename?.length === 0) {
      alert("Please enter template name");
      return;
    }

    if (paymentState?.length === 0) {
      alert("Please enter template description");
      return;
    }

    setIsCallingAddToTemplateListApi(true);

    let objectToSend = [
      {
        CmpCode: company_code_from_local_storage,
        mode: "ENTRY",
        mastercode: templatename,
        description: paymentState,
      },
    ];

    console.log("objectToSend to terms ", objectToSend);

    const apiUrl = `${apiPaths_from_local_storage[0].API_CONFIG}/api/TermsTemplate`;

    axios
      .post(apiUrl, objectToSend, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        setIsCallingAddToTemplateListApi(false);

        if (res.data.result === "Saved") {
          alert("templated added successfully");

          setShowAddToTemplateForm(false);
          setTemplateName("");
        } else {
          alert(
            "something went wrong, please enter different name or please try later"
          );
        }
      })
      .catch((err) => {
        setIsCallingAddToTemplateListApi(false);
        alert("something went wrong please try later");
      });
  };

  const clearLocalStorge = () => {};

  const companyCode = localStorage.getItem("companyCode") || "-";
  const apiPaths = localStorage.getItem("apiPaths")
    ? JSON.parse(localStorage.getItem("apiPaths"))
    : "-";
  const BASE_URL = apiPaths[0]?.API_CONFIG || "https://cubixweberp.com:213";
  const departmentLocation = localStorage.getItem("departmentLocation") || "A";

  // Fetch total count for modal stock listing
  const fetchModalTotalCount = useCallback(
    async (query = modalSearchQuery, searchByValue = searchBy) => {
      try {
        const effectiveQuery =
          query?.trim() === "" ? "-" : query?.trim() || "-";
        const formattedQuery = effectiveQuery.replace(/\//g, "%2F");
        const url = `${BASE_URL}/api/cpayscount/${companyCode}/ITEMCOUNT/${searchByValue}/${formattedQuery}`;
        const response = await request({
          url: url,
          method: "GET",
          timeout: 5000,
        });
        if (Array.isArray(response) && response[0]?.CNT) {
          setModalTotalRows(Number(response[0].CNT));
        } else {
          setModalTotalRows(0);
        }
      } catch (err) {
        console.error("Failed to fetch total count", err);
        setModalTotalRows(0);
      }
    },
    [BASE_URL, companyCode, searchBy, modalSearchQuery]
  );

  const fetchProductData = useCallback(
    async (
      query = modalSearchQuery,
      searchByValue = searchBy,
      location = departmentLocation,
      pageNum = modalPageNumber,
      limit = modalPageSize
    ) => {
      const effectiveQuery = query?.trim() === "" ? "-" : query?.trim() || "-";
      const formattedQuery = effectiveQuery.replace(/\//g, "%2F");

      try {
        const url = `${BASE_URL}/api/CRMStockListPage/${companyCode}/${searchByValue}/${formattedQuery}/${location}/-/${pageNum}/${limit}`;
        const response = await request({
          url: url,
          method: "GET",
          timeout: 5000,
        });
        if (response) {
          setModalSuggestions(response);
          return response;
        } else {
          setModalSuggestions([]);
          return [];
        }
      } catch (err) {
        console.error("Failed to fetch product data", err);
        setModalSuggestions([]);
        return [];
      }
    },
    [
      BASE_URL,
      companyCode,
      searchBy,
      modalPageNumber,
      modalPageSize,
      departmentLocation,
      modalSearchQuery,
    ]
  );

  const handleModalSearchQueryChange = useCallback(
    async (query = "-") => {
      setModalSearchQuery(query);
      setModalPageNumber(1);
      fetchProductData(query, searchBy, departmentLocation, 1, modalPageSize);
      fetchModalTotalCount(query, searchBy);
    },
    [
      fetchProductData,
      fetchModalTotalCount,
      searchBy,
      modalPageSize,
      departmentLocation,
    ]
  );

  useEffect(() => {
    if (f2PopupViewToggle) {
      fetchProductData(
        modalSearchQuery,
        searchBy,
        departmentLocation,
        modalPageNumber,
        modalPageSize
      );
      fetchModalTotalCount(modalSearchQuery, searchBy);
    }
  }, [
    modalPageNumber,
    modalPageSize,
    f2PopupViewToggle,
    searchBy,
    fetchProductData,
    fetchModalTotalCount,
    modalSearchQuery,
    departmentLocation,
  ]);

  const deleteTemplate = async (mastercodeFromClick) => {
    let company_code_from_local_storage = localStorage.getItem("companyCode")
      ? localStorage.getItem("companyCode")
      : "-";
    const deleteArray = [
      {
        CmpCode: company_code_from_local_storage,
        mode: "DELETE",
        mastercode: mastercodeFromClick,
        description: "-",
      },
    ];

    let serializedData = JSON.stringify(deleteArray);

    const apiUrl = `${apiPaths_from_local_storage[0].API_CONFIG}/api/TermsTemplate`; // Replace with your API URL

    try {
      console.log("Request Data:", serializedData); // Debug the request payload
      const response = await axios.post(apiUrl, serializedData, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      console.log("API Response:", response.data);

      if (response.data?.result.trim()?.toUpperCase() === "SAVED") {
        alert("template deleted successfully");
        getTemplatelist();
      } else {
        alert("something went wrong please try later");
      }
    } catch (error) {
      console.error("Error Sending API:", error);
      alert("Failed to delete template");
    }
  };

  const fetchCashCustomerList = async (value) => {
    if (!value || value.length < 1) {
      return;
    }

    let company_code_from_local_storage = localStorage.getItem("companyCode")
      ? localStorage.getItem("companyCode")
      : "-"; // only if user manually delete the key else condition would work , not even possible because if deleted then will be blocked at machine registration checking
    let apiPaths_from_local_storage = localStorage.getItem("apiPaths")
      ? JSON.parse(localStorage.getItem("apiPaths"))
      : "-";

    try {
      const url = `${apiPaths_from_local_storage[0].API_CONFIG}/api/CRMAccountList/${company_code_from_local_storage}/WALKINLIST/${userDepartment}/ALL/-/${value}`;

      const response = await axios.get(url);
      setCashCustomerList(response.data);
    } catch (error) {
      console.log("Error fetching organization details:", error);
    }
  };

  function calculatePercentage() {

    let amountForPercentage = productsInQuotationState?.filter((item) => {
      if (item.itemCustRef == "OPT" || item.itemCustRef == "OPTION") {
        return false
      }
      else {
        return true
      }
    }).reduce((acc, curr) => {
      if (curr.Lead_ID) {
        return (acc = acc + curr.Prod_Qty * curr.Prod_Price);
      } else {
        return (acc = acc + curr.itemQuantity * curr.itemPrice);
      }
    }, 0)

    let discountValueAfterCalc = (discountPercentage / 100) * amountForPercentage;

    setDiscountValue(parseFloat(discountValueAfterCalc.toFixed(2)))
  }

  return (
    <ThemeProvider theme={theme}>
      <div
        id="quotation-content"
        className=" quotation-container lg:w-full w-[100vw] lg:px-4 px-2 mb-4 rounded-md  max-h-[100vh] overflow-y-auto scrollbar-thin"
      >
        {showPDFDialogBox && (
          <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
            <div className="bg-white p-4 rounded-lg shadow-lg max-w-md w-full mx-4">
              <h2 className="text-2xl font-semibold text-gray-800 mb-6 text-center">
                Quotation Data Saved Successfully!
              </h2>
              <div className="flex justify-center space-x-4">
                {/* <button
                  onClick={navigateToPDF}
                  className="px-4 py-2 rounded-lg bg-blue-500 text-white hover:bg-blue-600 transition duration-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                >
                  View PDF
                </button> */}

                <button
                  onClick={() => {
                    setShowPDFDialogBox(false);
                    // Refresh quotation details to allow further editing/viewing on the same page
                    checkingForQuotation(selectedLead);
                  }}
                  className="px-4 py-2 rounded-lg bg-indigo-500 text-white hover:bg-indigo-600 transition duration-300 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                >
                  Stay on this Page
                </button>

                <button
                  onClick={() => {
                    setShowPDFDialogBox(false);
                    navigate("/quotationsListViewFull");
                  }}
                  className="px-4 py-2 rounded-lg bg-gray-500 text-white hover:bg-gray-600 transition duration-300 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2"
                >
                  Go to Quotation List
                </button>
              </div>
            </div>
          </div>
        )}

        {isQuotationRoute && (
          <div
            role="presentation"
            className="bg-gray-100 pl-4 py-3 rounded-md shadow w-80"
          >
            <Breadcrumbs
              aria-label="breadcrumb"
              className="flex items-center space-x-0 text-gray-600 "
            >
              {/* Qualified Leads Breadcrumb */}
              <Link
                className="flex items-center space-x-1 text-gray-700 hover:text-blue-600"
                underline="hover"
                color="inherit"
                component={RouterLink}
                to="/qualifiedLeadsTable"
              >
                <span className="material-icons text-sm">home</span>
                <h2 className="text-base font-medium truncate">
                  Qualified Leads
                </h2>
              </Link>

              {/* Quotation Breadcrumb (conditionally rendered) */}
              {isQuotationRoute && (
                <Link
                  className="flex items-center space-x-1 text-gray-700 hover:text-blue-600 "
                  underline="hover"
                  color="inherit"
                  component={RouterLink}
                  to={location.pathname}
                >
                  <span className="material-icons text-sm">receipt</span>
                  <h2 className="text-base font-medium truncate">Quotation</h2>
                </Link>
              )}
            </Breadcrumbs>
          </div>
        )}

        {productsInQuotationState?.some(
          (prod) => !prod.isSelectedItemCodeCorrect && prod.itemCode?.length > 0
        ) ? (
          <Snackbar
            open={openSnackbar}
            autoHideDuration={3000}
            onClose={handleCloseSnackbar}
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
          >
            <MuiAlert
              onClose={handleCloseSnackbar}
              severity="error"
              sx={{ width: "100%" }}
            >
              {`Item Code is not Correct at row ${errorRow} `}
            </MuiAlert>
          </Snackbar>
        ) : (
          <Snackbar
            open={openSubmitSnackbar}
            autoHideDuration={3000}
            onClose={handleCloseSubmitSnackbar}
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
          >
            <MuiAlert
              onClose={handleCloseSnackbar}
              severity="success"
              sx={{ width: "100%" }}
            >
              Form Submitted Successfully!
            </MuiAlert>
          </Snackbar>
        )}

        {duplicateItemCodeSnackbar && (
          <Snackbar
            open={duplicateItemCodeSnackbar}
            autoHideDuration={3000}
            onClose={handleCloseSubmitSnackbar}
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
          >
            <MuiAlert
              onClose={handleCloseSnackbar}
              severity="error"
              sx={{ width: "100%" }}
            >
              This item is already selected. Duplicate entries are not allowed!
            </MuiAlert>
          </Snackbar>
        )}

        <div className="flex lg:flex-row flex-col lg:gap-4 justify-between lg:items-center items-start">
          {/* Tabs Section */}
          <Box sx={{ width: "100%", overflowX: "auto" }}>
            <Tabs
              value={selectedTab1}
              onChange={handleTab1Change}
              textColor="primary"
              indicatorColor="primary"
            >
              <Tab label="Sale" />
              <Tab label="Customer Details" />
              {/* <Tab label="Customer History" /> */}
            </Tabs>
          </Box>

          <div className="flex lg:flex-nowrap flex-wrap items-center gap-4  p-4 rounded-md">
            {/* <button
              onClick={() => clearLocalStorge()}
              className="px-4 py-2 rounded-lg bg-red-500 text-white hover:bg-red-600 transition duration-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
            >
              Clear Data
            </button> */}

            <div>
              <p className="text-sm text-gray-600">Amount</p>
              {/* <p className="text-xl font-semibold">
                {productsInQuotationState
                  ? productsInQuotationState?.filter((item) => item.itemCustRef != "OPT")?.reduce((acc, curr) => {
                    if (curr.Lead_ID) {
                      return (acc = acc + curr.Prod_Qty * curr.Prod_Price);
                    } else {
                      return (acc = acc + curr.itemQuantity * curr.itemPrice);
                    }
                  }, 0) + vatValue
                  : "--"}
              </p> */}

              <span style={{ fontWeight: "bold" }}>
                {productsInQuotationState
                  ?.filter((item) => {
                    if (
                      item.itemCustRef?.trim()?.toUpperCase() === "OPT" ||
                      item.itemCustRef?.trim()?.toUpperCase() === "OPTION"
                    ) {
                      return false;
                    } else {
                      return true;
                    }
                  })
                  .reduce((acc, curr) => {
                    if (curr.Lead_ID) {
                      return (acc = acc + curr.Prod_Qty * curr.Prod_Price);
                    } else {
                      return (acc = acc + curr.itemQuantity * curr.itemPrice);
                    }
                  }, 0) -
                  discountValue +
                  (vatValue ? vatValue : "")}
              </span>
            </div>

            {quotationNumberOfThisLead && (
              <button
                onClick={navigateToPDF}
                className="px-4 py-2 rounded-lg bg-blue-500 text-white hover:bg-blue-600 transition duration-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
              >
                View PDF
              </button>
            )}

            {/* NEW – Excel button */}
{quotationNumberOfThisLead && (
  <button
    onClick={() =>
      downloadQuotationExcel({
        selectedLead,
        formattedDate: `${String(new Date().getDate()).padStart(2,"0")}-${String(new Date().getMonth()+1).padStart(2,"0")}-${new Date().getFullYear()}`,
        productsInQuotationFromAPI: productsInQuotationAsFromApiForPDF,
        vatValue,
        discountValue,
        alreadySentQuotationNumber,
        salesOrderYesOrNo : null,
      })
    }
    className="px-4 py-2 rounded-lg bg-green-600 text-white hover:bg-green-700 transition duration-300 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2"
  >
    ⬇ Excel
  </button>
)}

            <button
              onClick={handleRedirect}
              className="px-4 py-1 rounded-md text-red-500 border border-red-500 bg-white hover:bg-red-100 transition"
            >
              Cancel
            </button>

            <button
              className="bg-pink-500 hover:bg-pink-600 text-white px-2 py-1 rounded"
              onClick={onQuotationList}
            >
              Quotation List
            </button>
          </div>

          {/* </div> */}
        </div>
        <Box
          className=""
          sx={{
            p: "10px 8px 16px 16px",
            mt: 0,
            border: "1px solid #ccc",
            borderRadius: "4px",
            backgroundColor: "#fff",
          }}
        >
          {selectedTab1 === 0 && (
            <SalesTab
              mode="quotation"
              selectedLead={selectedLead}
              customerType={customerType}
              onCustomerTypeChange={handleCustomerTypeChange}
              sendForApprovalClicked={sendForApprovalClicked}
              productsInQuotationState={productsInQuotationState}
              vat={vat}
              setVat={setVat}
              callApisAgainInQuoteLead={callApisAgainInQuoteLead}
              giveNextActionArrayToParent={giveNextActionArrayToParent}
              setTypedAccountFromChild={setTypedAccountFromChild}
              setTypedCustomerNameFromChild={setTypedCustomerNameFromChild}
              setTypedProjectNameFromChild={setTypedProjectNameFromChild}
              setTypedSalesPersonId={setTypedSalesPersonId}
              typedAccountFromChild={typedAccountFromChild}
              typedCustomerNameFromChild={typedCustomerNameFromChild}
              typedProjectNameFromChild={typedProjectNameFromChild}
              typedSalesPersonId={typedSalesPersonId}
              setSelectedCustomerObject={setSelectedCustomerObject}
              selectedCustomerObject={selectedCustomerObject}
              salespersonList={salespersonList}
              coordinatorList={coordinatorList}
              setTypedCoordinatorId={setTypedCoordinatorId}
              typedCoordinatorId={typedCoordinatorId}
              setProductsInQuotation={setProductsInQuotation}
              handleAddRow={handleAddRow}
              setCashCustomerList={setCashCustomerList}
              cashCustomerList={cashCustomerList}
              fetchCashCustomerList={fetchCashCustomerList}
              setShowDropdown={setShowDropdown}
              showDropdown={showDropdown}
              setTypedEmailForQuotationFromChild ={setTypedEmailForQuotationFromChild}
              typedEmailForQuotationFromChild = {typedEmailForQuotationFromChild}
              setTypedMobileForQuotationFromChild = {setTypedMobileForQuotationFromChild}
              typedMobileForQuotationFromChild = {typedMobileForQuotationFromChild}
              settingDataGotFromQuotationDetailsApiToScreen = {settingDataGotFromQuotationDetailsApiToScreen}

            />
          )}
          {selectedTab1 === 1 && (
            <CustomerDetailsTab
              selectedLead={selectedLead}
              subject={customerSubject} // Pass state variable
              setCustomerSubject={setCustomerSubject} // Pass setter function
              customerTRN={customerTRN} // Pass state variable
              setCustomerTRN={setCustomerTRN} // Pass setter function
              setCustomerAddress={setCustomerAddress}
              customerAddress={customerAddress}
              quotationNumberOfThisLead={quotationNumberOfThisLead}
              setAttentionInQuotation={setAttentionInQuotation}
              attentionInQuotation={attentionInQuotation}
            />
          )}
          {selectedTab1 === 2 && <OtherDetailsTab />}
          {selectedTab1 === 3 && <OtherDetailsTab />}
        </Box>

        {/* <Box
          sx={{
            height: 300,
            width: "100%",
            marginTop: "1rem",
            border: "1px solid #ccc",
          }}
        >
          <DataGrid
            rows={leadItems}
            columns={columns}
            getRowId={(row) => row.id}
            // checkboxSelection
            disableSelectionOnClick
            hideFooterPagination
            hideFooter
            density="compact"
            onRowSelectionModelChange={(newSelection) => {
              setSelectedProductRows(newSelection); // ✅ Updates selected rows manually
            }}
            rowSelectionModel={selectedRows} // ✅ Ensures controlled selection
          />
        </Box> */}

        <ProductsInQuotation
          // lead={formData.lead}
          productEntryInAllEntries={productEntryInAllEntries}
          productEntries={productEntries}
          productsInQuotationState={productsInQuotationState}
          deleteSelectedRows={deleteSelectedRows}
          markFOCForSelectedRows={markFOCForSelectedRows}
          markSubstituteForSelectedRows={markSubstituteForSelectedRows}
          setProductEntries={setProductEntries}
          handleAddRow={handleAddRow}
          handleDeleteSelected={handleDeleteSelected}
          handleInputChange={handleInputChange}
          selectProduct={selectProduct}
          selectedRows={selectedRows}
          setSelectedRows={setSelectedRows}
          currentProductEntryRowId={currentProductEntryRowId}
          productData={productData}
          setCurrentF2ItemForSearchPopup={setCurrentF2ItemForSearchPopup}
          rowInputRefs={rowInputRefs}
          qtyInputRefsFromParent={qtyInputRefsFromParent}
        />

        <div
          // className=" lg:w-[30%] w-full flex-col flex ml-auto"
          style={{
            display: "flex",
            flexDirection: "column",
            width: "30%",
            marginLeft: "auto",
          }}
          
        >
          <div className=" flex justify-between ">
            <p>Amount </p>
            <span style={{ fontWeight: "bold" }}>
              {productsInQuotationState
                ?.filter((item) => {
                  if (
                    item.itemCustRef?.trim()?.toUpperCase() === "OPT" ||
                    item.itemCustRef?.trim()?.toUpperCase() === "OPTION"
                  ) {
                    return false;
                  } else {
                    return true;
                  }
                })
                .reduce((acc, curr) => {
                  if (curr.Lead_ID) {
                    return (acc = acc + curr.Prod_Qty * curr.Prod_Price);
                  } else {
                    return (acc = acc + curr.itemQuantity * curr.itemPrice);
                  }
                }, 0)
                ?.toFixed(2)}
            </span>
          </div>

          <div className=" flex justify-between ">
            <p style={{ marginRight: "30px" }}>Special Discount</p>
            
            <TextField

              sx={{ width: 70 }}
              value={discountPercentage}
              size="small"
              variant="standard"
              placeholder="Disc. %"
              type="number"
              inputProps={{ min: 0, style: { textAlign: 'right' } }}
              onChange={(e) => setDiscountPercentage(e.target.value)}
            />

            <button onClick={() => calculatePercentage()} class="bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"> <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 12h14M13 5l7 7-7 7" />
            </svg></button>
            
            <TextField
              width="50px"
              value={discountValue}
              size="small"
              variant="standard"
              type="number"
              inputProps={{ min: 0, style: { textAlign: "right" } }}
              onChange={(e) => {
                const inputValue =
                  e.target.value === "" ? 0 : parseFloat(e.target.value);

                const totalPrice =
                  productsInQuotationState
                    ?.filter((item) => {
                      if (
                        item.itemCustRef?.trim()?.toUpperCase() === "OPT" ||
                        item.itemCustRef?.trim()?.toUpperCase() === "OPTION"
                      ) {
                        return false;
                      } else {
                        return true;
                      }
                    })
                    .reduce((acc, curr) => {
                      if (curr.Lead_ID) {
                        return acc + curr.Prod_Qty * curr.Prod_Price;
                      } else {
                        return acc + curr.itemQuantity * curr.itemPrice;
                      }
                    }, 0) || 0;

                // Convert to number for proper numerical comparison
                if (inputValue <= totalPrice) {
                  setDiscountValue(e.target.value);
                }
              }}
            />
          </div>
          <div className=" flex justify-between ">
            <p>
              Taxable Amount{" "}
              {console.log(
                "productsInQuotationState taxable amount ",
                productsInQuotationState
              )}
            </p>
            <span style={{ fontWeight: "bold" }}>
              {isNaN(
                productsInQuotationState
                  ?.filter((item) => {
                    if (
                      item.itemCustRef?.trim()?.toUpperCase() === "OPT" ||
                      item.itemCustRef?.trim()?.toUpperCase() === "OPTION"
                    ) {
                      return false;
                    } else {
                      return true;
                    }
                  })
                  .reduce((acc, curr) => {
                    return acc + curr.itemQuantity * curr.itemPrice;
                  }, 0) - (discountValue ? discountValue : 0)
              )
                ? "--"
                : (
                    productsInQuotationState
                      ?.filter((item) => {
                        if (
                          item.itemCustRef?.trim()?.toUpperCase() === "OPT" ||
                          item.itemCustRef?.trim()?.toUpperCase() === "OPTION"
                        ) {
                          return false;
                        } else {
                          return true;
                        }
                      })
                      .reduce((acc, curr) => {
                        return acc + curr.itemQuantity * curr.itemPrice;
                      }, 0) - (discountValue ? discountValue : 0)
                  )?.toFixed(2)}
            </span>
          </div>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <p>Vat % </p>
            {/* <span style={{ fontWeight: "bold" }}>{vatValue === 0 ? 0 : 5}</span> */}
            {console.log("vatValue-->", vatValue)}
            <span style={{ fontWeight: "bold" }}>
              {vatValue === 0 ? 0 : dynamicVatFromAPI}
            </span>
          </div>
          <div className=" flex justify-between ">
            <p>Vat Amount</p>
            <span style={{ fontWeight: "bold" }}>
              {vatValue ? parseFloat(vatValue).toFixed(2) : "--"}
            </span>{" "}
          </div>
          <div className=" flex justify-between ">
            <p>Total Amount </p>
            <span style={{ fontWeight: "bold" }}>
              {isNaN(
                productsInQuotationState
                  ?.filter((item) => {
                    if (
                      item.itemCustRef?.trim()?.toUpperCase() === "OPT" ||
                      item.itemCustRef?.trim()?.toUpperCase() === "OPTION"
                    ) {
                      return false;
                    } else {
                      return true;
                    }
                  })
                  .reduce((acc, curr) => {
                    return acc + curr.itemQuantity * curr.itemPrice;
                  }, 0) - (discountValue ? discountValue : 0)
              )
                ? "--"
                : parseFloat(
                    productsInQuotationState
                      ?.filter((item) => {
                        if (
                          item.itemCustRef?.trim()?.toUpperCase() === "OPT" ||
                          item.itemCustRef?.trim()?.toUpperCase() === "OPTION"
                        ) {
                          return false;
                        } else {
                          return true;
                        }
                      })
                      .reduce((acc, curr) => {
                        return acc + curr.itemQuantity * curr.itemPrice;
                      }, 0) -
                      (discountValue ? discountValue : 0) +
                      (!isNaN(vatValue) ? vatValue : 0)
                  ).toFixed(2)}
            </span>{" "}
          </div>
        </div>

        <Box className="flex lg:flex-row  flex-col-reverse justify-between items-center gap-4">
          <div>
            <Tabs
              value={selectedTab2}
              onChange={handleTab2Change}
              textColor="primary"
              indicatorColor="primary"
            >
              <Tab label="Terms & Conditions" />
            </Tabs>
          </div>
          <div className="flex  items-center space-x-4 justify-center ">
            {/* Currency Selector */}
            <div className="mb-0   flex items-center space-x-4">
              <TextField
                select
                label="Currency"
                name="currency"
                slotProps={{
                  input: { readOnly: true },
                }}
                value={currency} // Keep only this one
                onChange={handleCurrency}
                variant="standard"
                sx={{
                  width: "100px",
                  "& .MuiInputLabel-root": {
                    fontFamily: "Figtree, sans-serif",
                  },
                }}
              >
                {currencyList?.map((item) => (
                  <MenuItem key={item.curno} value={item.curno}>
                    {item.curno}
                  </MenuItem>
                ))}
              </TextField>

              {/* Booked Amount */}
              <TextField
                label="Rate"
                name="bookedAmount"
                type="number"
                slotProps={{
                  input: { readOnly: true },
                }}
                // value={formData.bookedAmount || ""} // Separate state for booked amount
                value={currencyList && currencyList[0]?.rate} // Separate state for booked amount
                onChange={handleCurrencyAmount}
                fullWidth
                variant="standard"
                InputProps={{
                  inputProps: { min: 0 }, // Prevent negative amounts
                }}
                sx={{
                  "& .MuiInputLabel-root": {
                    fontFamily: "Figtree, sans-serif",
                  },
                }}
              />
            </div>

            <div className=" ">
              <FormControlLabel
                control={
                  <Switch
                    checked={vatIncluded}
                    onChange={handleToggle}
                    color="primary"
                  />
                }
                label="Include VAT"
              />
              <TextField
                label="VAT"
                value={parseFloat(vatValue).toFixed(2)}
                size="small"
                variant="standard"
                InputProps={{
                  readOnly: true, // Make the field read-only to reflect the VAT value
                }}
              />
            </div>
          </div>

          {/* Tabs Section */}
          {/* <Box> */}
        </Box>

        <Box
          sx={{
            p: 2,
            mt: 2,
            border: "1px solid #ccc",
            borderRadius: "4px",
            backgroundColor: "#fff",
          }}
        >
          {/* {selectedTab2 === 0 && (
            <div>Delivery details: Delivered within 7 business days.</div>
          )}
          {selectedTab2 === 1 && (
            <div>Payment terms: 50% advance, 50% upon delivery.</div>
          )}
          {selectedTab2 === 2 && (
            <div>Validity: Quotation valid for 30 days from issuance.</div>
          )}
          {selectedTab2 === 3 && (
            <div>
              Remarks: Please ensure all details are accurate before confirming.
            </div>
          )} */}
          {selectedTab2 === 0 && (
            <div>
              <div className="flex">
                <div style={{ position: "relative" }}>
                  <button
                    className="px-4 py-2 rounded-md text-sm  text-white bg-blue-500 hover:bg-gray-800 transition"
                    onClick={() => setShowHideTemplateList((prev) => !prev)}
                  >
                    Terms template List
                  </button>

                  <div
                    className=" absolute lg:bg-white bg-transparent lg:border border-none"
                    style={{
                      top: "40px",
                      width: "300px",
                    }}
                  >
                    {isCallingTemplateListApi && (
                      <div role="status">
                        <svg
                          aria-hidden="true"
                          class="w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600"
                          viewBox="0 0 100 101"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                            fill="currentColor"
                          />
                          <path
                            d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                            fill="currentFill"
                          />
                        </svg>
                      </div>
                    )}

                    {showHideTemplateList && (
                      <div
                        style={{
                          height: "200px",
                          overflowY: "scroll",
                          backgroundColor: "#f7f7f7",
                          border: "1px solid #3b82f6",
                        }}
                      >
                        {termsTemplatelist && termsTemplatelist.length > 0 ? (
                          termsTemplatelist.map((item) => {
                            return (
                              <div
                                key={item.mastercode}
                                className="p-2 cursor-pointer hover:bg-gray-100 border-b border-gray-200 flex justify-between items-center"
                                onClick={() =>
                                  getTermsTemplateDetails(item.mastercode)
                                }
                              >
                                <p className="text-sm font-medium text-gray-700 truncate flex-1">
                                  {item.mastercode}
                                </p>
                                <button
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    setConfirmDeleteTemplate(item.mastercode); // store which one to delete
                                  }}
                                  className="ml-2 p-1 text-red-500 hover:text-red-700 hover:bg-red-100 rounded transition-colors duration-200"
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    className="h-4 w-4"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    stroke="currentColor"
                                  >
                                    <path
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      strokeWidth={2}
                                      d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                                    />
                                  </svg>
                                </button>
                              </div>
                            );
                          })
                        ) : (
                          <div className="flex flex-col items-center justify-center h-full text-gray-400">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              className="h-8 w-8 mb-2"
                              fill="none"
                              viewBox="0 0 24 24"
                              stroke="currentColor"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                              />
                            </svg>
                            <p className="text-sm">No templates found</p>
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                </div>

                <button
                  className="ms-2 mb-2 px-4 py-2 rounded-md text-sm  text-white bg-blue-500 hover:bg-gray-800 transition"
                  onClick={() => setShowAddToTemplateForm((prev) => !prev)}
                >
                  Add To Template
                </button>
              </div>
              {showAddToTemplateForm && (
                <div className="mt-2">
                  {isCallingAddToTemplateListApi && (
                    <div role="status">
                      <svg
                        aria-hidden="true"
                        class="w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600"
                        viewBox="0 0 100 101"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                          fill="currentColor"
                        />
                        <path
                          d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                          fill="currentFill"
                        />
                      </svg>
                    </div>
                  )}

                  <div className="flex gap-2 items-center">
                    <input
                      placeholder="Enter template name"
                      onChange={(e) => setTemplateName(e.target.value)}
                      className="w-48 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm"
                      onFocus={(e) => (e.target.style.borderColor = "#3b82f6")}
                      onBlur={(e) => (e.target.style.borderColor = "#d1d5db")}
                    />

                    <button
                      className="ms-2 px-4 py-2 rounded-md text-sm  text-white bg-blue-500 hover:bg-gray-800 transition"
                      onClick={() => saveToTermsTemplate()}
                    >
                      Add
                    </button>
                    <div className="flex items-start gap-1 text-gray-400 text-xs px-2 py-1 italic">
                      <span>
                        ( Note: Name the template{" "}
                        <span className="font-semibold">"default"</span> to
                        auto-load it as the default payment terms. )
                      </span>
                    </div>
                  </div>
                </div>
              )}
              <textarea
                className="w-full h-40 border border-gray-300 rounded p-2 focus:outline-none focus:ring-1 focus:ring-blue-400"
                value={paymentState}
                onChange={(e) => updatePaymentTerms(e)}
              ></textarea>
            </div>
          )}
        </Box>
        {/* </Box> */}

        {console.log("productsInQuotationState-->", productsInQuotationState)}
        {selectedLead === null ? (
          <div className="p-6 flex justify-center items-center ">
            <button
              // onClick={togglePopup}
              onClick={handleSaveQuotationNew}
              className="px-4 py-2 rounded-md w-[200px] text-white bg-green-600 hover:bg-gray-800 transition"
            >
              Save
            </button>
          </div>
        ) : (
          <div className="p-6 flex justify-center items-center ">
            {console.log(
              "productinQuotation before Savw>> ",
              productsInQuotationState
            )}

            {
              // "Customer Submission & Awaiting Approval" this was commented because sanira of sunrise told they want to edit also in this stage
              productsInQuotationState?.length > 0 ? (
                productsInQuotationState[0].area_code === "For Approval" ||
                productsInQuotationState[0].area_code === "Approved" ||
                // productsInQuotationState[0].area_code ==
                //   "Customer Submission & Awaiting Approval" ||
                productsInQuotationState[0].area_code === "Customer Approval" ||
                productsInQuotationState[0].area_code === "Won -Sales Order" ? (
                  <p style={{ color: "#f00" }}>
                    Cannot Save while Quotation Stage is{" "}
                    {productsInQuotationState[0].area_code}
                  </p>
                ) : (
                  <button
                    // onClick={togglePopup}
                    onClick={handleSaveQuotation}
                    className="px-4 py-2 rounded-md w-[200px] text-white bg-black hover:bg-gray-800 transition"
                  >
                    Save
                  </button>
                )
              ) : (
                <p>Please add alteast one item to save</p>
              )
              // <button
              //   // onClick={togglePopup}
              //   onClick={handleSaveQuotation}
              //   className="px-4 py-2 rounded-md w-[200px] text-white bg-black hover:bg-gray-800 transition"
              // >
              //   Save
              // </button>
            }
          </div>
        )}

        <ImageModal
          modalImage={modalImage}
          openModal={openModal}
          onClose={() => setOpenModal(false)} // Close modal handler
          onImageChange={(e) => {
            const file = e.target.files[0];
            if (file) {
              const newImageUrl = URL.createObjectURL(file);
              setModalImage(newImageUrl); // Update the modal image

              // Update the product image in the products state
              setProducts((prevProducts) =>
                prevProducts.map((product) =>
                  product.image === modalImage // Find the product with the matching image
                    ? { ...product, image: newImageUrl } // Update its image
                    : product
                )
              );
            }
          }}
        />
      </div>

      <Modal
        isOpen={f2PopupViewToggle}
        onClose={() => setF2PopupViewToggle(false)}
        title={"Products List"}
        size="xxl"
        header={true}
      >
        <div className="product-modal-container">
          <ProductsModal
            modalSuggestions={modalSuggestions}
            handleProductSelect={(product) => {
              console.log("product", product);

              const rowId = currentF2ItemForSearchPopup.id;

              setProductsInQuotation((prevEntries) =>
                prevEntries.map((entry) =>
                  entry.id === currentF2ItemForSearchPopup.id
                    ? {
                        ...entry,
                        itemCode: product.Code,
                        itemDescription: product.Description,
                        itemImage: product.Imagepath,
                        // itemUnit: product.unit,
                        itemUnit: product.Unit,
                        itemCurrentStock: product.Ttl_Stk, // Adjust according to your product data
                        itemPrice: product.SelPrice, // Adjust according to your product data
                        itemAmount: product.SelPrice * entry.itemQuantity, // Example calculation
                        isSelectedItemCodeCorrect: true, // Example calculation
                      }
                    : entry
                )
              );
              setF2PopupViewToggle(false);
              setTimeout(() => {
                if (qtyInputRefsFromParent.current[rowId]) {
                  qtyInputRefsFromParent.current[rowId].focus();
                  qtyInputRefsFromParent.current[rowId].select();
                }
              }, 0);
            }}
            onSearchQueryChange={handleModalSearchQueryChange}
            loading={loading}
            setSearchBy={setSearchBy}
            searchBy={searchBy}
            pageNumber={modalPageNumber}
            pageSize={modalPageSize}
            totalRows={modalTotalRows}
            onPageChange={setModalPageNumber}
            searchQuery={modalSearchQuery}
            onRefresh={() =>
              fetchProductData(
                modalSearchQuery,
                searchBy,
                "A",
                modalPageNumber,
                modalPageSize
              )
            }
          />
        </div>
      </Modal>

      {confirmDeleteTemplate && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="bg-white p-6 rounded-lg shadow-lg max-w-sm w-full mx-4">
            <h2 className="text-lg font-semibold text-gray-800 mb-2">
              Delete Template
            </h2>
            <p className="text-sm text-gray-600 mb-6">
              Are you sure you want to delete{" "}
              <span className="font-bold text-red-500">
                {confirmDeleteTemplate}
              </span>
              ? This cannot be undone.
            </p>
            <div className="flex justify-end gap-3">
              <button
                onClick={() => setConfirmDeleteTemplate(null)} // cancel
                className="px-4 py-2 rounded-md text-sm text-gray-700 bg-gray-100 hover:bg-gray-200 transition"
              >
                Cancel
              </button>
              <button
                onClick={() => {
                  deleteTemplate(confirmDeleteTemplate); // confirm delete
                  setConfirmDeleteTemplate(null); // close popup
                }}
                className="px-4 py-2 rounded-md text-sm text-white bg-red-500 hover:bg-red-600 transition"
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      )}
    </ThemeProvider>
  );
};

export default QuotationComponent;